<template lang="pug">
div
  section
    div
      InfoNotice(v-if="deliveryUnavailable", :text="$t('DELIVERY_PROFILE_NOT_VALID')")
      .mt-12.text-red-500(v-if="!loading.main && hasApiError", data-qa="checkout-api-errors")
        div(v-for="(error, index) in apiErrors", :key="index") {{ getError(error) }}
      //- step 1 по старой логике
      AlreadyAuthedNotice(v-if="!authed && !isFriendOrBuyerFromFriend" @open-auth="openAuth", data-qa="checkout-already-authed-notice")
      .flex.flex-col
        BannerBlock(v-if="!authed && !isFriendOrBuyerFromFriend", data-qa="checkout-banner-block")
        OldStep1(v-if="!authed && !isFriendOrBuyerFromFriend", @change="memberId = $event", data-qa="checkout-old-step1")

        ChooseAddress(
          v-if="authed",
          v-model:modelValue="selectedProfileId",
          :isProcessing="isProcessing",
          :deliveryUnavailable="deliveryUnavailable",
          @createNewAddress="handleCreateNewAddress",
          data-qa="checkout-choose-address"
        )
        .steps-group
          //- step 2
          StepFio(
            ref="stepFioRef"
            :step="isFriendOrBuyerFromFriend ? 2 : step"
            :modelValue="userInfo"
            :shouldCheckDuplicates="isBuyerFromFriend"
            :duplicateCheckLoading="duplicateCheckInProgress"
            :mustEditField="mustEditBeforeNextStep"
            v-model:profileAddressComment="profileAddressComment"
            @update:modelValue="updateFioFields"
            @update:isValid="isFioStepValid = $event"
            @checkDuplicate="checkDuplicateInDb"
          )

          //- step 3
          StepCity(
            ref="stepCity"
            :step="step"
            :loading="loading"
            :country="getCountry.code"
            :positionData="positionData"
            :countryRestriction="countryRestriction"
            :cityFieldLocked="localityCheck.cityFieldLocked"
          :choosePositionFromPositionModal="choosePositionFromPositionModal"
            :formPositionData="formPositionData"
            :checkPosition="checkPosition"
          )

          .step(:class="{'unactive': +step < 3}", ref="deliveryStepEl")
            h3(class="text-lg font-medium pb-3 lg:text-3xl") {{ titleDeliveryTypes }}
            .stepContent-fake(v-if="!loading.main", ref="step3container")
              //- здесь в основном эмитим данные
              StepDeliveryType(
                :loading="loading",
                :deliveryTypes="deliveryTypes",
                :positionData="positionData",
                :typesFilter="typesFilter",
                :showSearchTools="showSearchTools",
                :activeDeliveryType="activeDeliveryType",
                :selectedDeliveryService="selectedDeliveryService",
                :isSelectedProfile="isSelectedProfile",
                :lastServiceId="lastServiceId",
                @selectDeliveryType="setActiveDeliveryType($event)",
                @callback="getPaymentTypesByService($event)",
                @filterPickpointsByField="filterPickpointsByField($event)",
                @filterPickpointsByType="filterPickpointsByField",
                @passMapCords="setMapCordsForZoom($event)",
                @switchPickpointsTemplate="switchPickpointsTemplate($event)",
                @searchPickpoints="searchPickpoints($event)"
                @updateDeliveryType="updateDeliveryType($event)"
              )

              DdpBlock(@switch="dutyEnabled = $event", class="w-full mb-8 xl1920:w-10/12 lg1024:mb-12")
              //- TODO: красные и серые информеры выделить комментарием, что это блок с информацией

              purpleHolder.px-4.pt-3.pb-3.mb-8.radio-helper(v-if="getCountryCode === 'RU' && positionData.CITY_NAME === 'Санкт-Петербург' && $store.state.selectedDeliveryTypeService === 'I_COURIER_1DAY'", style="transform: translateY(-2em);")
                .radio-helper__container
                  ExclamationAlertIcon.radio-helper__icon(color="#726CE7", topPosition="0")
                  .radio-helper__text {{ $t('piter_notification') }}

              ChoosePickpoints(
                v-if="activeDeliveryType?.ID === 'PICK_POINT'"
                :loading="loading"
                :activeDeliveryTypeId="activeDeliveryType?.ID"
                :selectedPickpointInfo="selectedPickpointInfo"
                :activePickpoint="activePickpoint"
                :showPickpointInfoModal="showPickpointInfoModal"
                :activePickpointsTemplate="activePickpointsTemplate"
                :getAllPickpoints="getAllPickpoints"
                :positionData="positionData"
                :addressInfo="addressInfo"
                :zoomToCordsObj="zoomToCordsObj"
                :googleObject="googleObject"
                :mapOptions="mapOptions"
                :itemsToShow="itemsToShow"
                :formatMoney="formatMoney"
                :getDeliveryCompanyInfo="getDeliveryCompanyInfo"
                :activePickpointAddressModal="activePickpointAddressModal"
                :lastPickpointCode="lastPickpointCode"
                @selectPickpoint="selectPickpoint"
                @showPickpointInfo="showPickpointInfo"
                @closePickpointInfoModal="showPickpointInfoModal = false"
                @showMorePickpoints="showMorePickpoints"
              )

              CourierAddress(
                v-if="activeDeliveryType?.ID === 'COURIER'"
              :key="'courier-' + localityCheck.addressKey"

                v-model:modelValue="addressInfo"

                :addressFieldLocked="localityCheck.addressFieldLocked"
                :activeDeliveryTypeId="activeDeliveryType?.ID"
                :loadingMain="loading.main"
                :loadingMap="loading.map"

                :showMap="showMap"
                @update:showMap="showMap = $event"

                :showHiddenFields="showHiddenFields"
                @showHiddenFields="setHiddenFields(true)"
                @hideHiddenFields="setHiddenFields(false)"

                :hideGmapAutocomplete="hideGmapAutocomplete"

                :positionData="positionData"
                :countryRestriction="countryRestriction"
                :courierAddressMarker="courierAddressMarker"
                :zoomToCordsObj="zoomToCordsObj"
                :needDefaultZoom="needDefaultZoom"
                :googleObject="googleObject"
                :mapOptions="mapOptions"

                :getCountryCode="getCountry.code"
                :fieldsConfig="fieldsConfig"
                :errorMessages="errorMessages"
                :getFieldProp="getFieldPropertyValue"
                :validateField="validateField"
                :handleMaxLength="handleMaxLength"
                :formAddressField="formAddressField"
                :validateAddressField="validateAddressField"
                :onAddressFieldFocusOut="handleAddressFieldFocusOut"
                :focusAutocomplete="focusAutocomplete"
                :closePopup="closePopup"

                :englishAddress="englishAddress"
                :getAutocompleteLabel="getAutocompleteLabel"
                :kyivOutside="kyivOutside"
                :spbOutside="spbOutside"
                :moscowOutside="moscowOutside"

                @get-address-info="formAddressField"
                @closePopup="closePopup"
                @manualAddressChange="onManualAddressChange"
              )

              PostAddress(
                v-if="activeDeliveryType?.ID === 'POST'"

                v-model="addressInfo"
                v-model:profileAddressComment="profileAddressComment"

                :activeDeliveryTypeId="activeDeliveryType?.ID"
                :positionData="positionData"
                :countryRestriction="countryRestriction"
                :getCountryCode="getCountry.code"
                :getFieldPropertyValue="getFieldPropertyValue"
                :validateField="validateField"
                :handleMaxLength="handleMaxLength"
                :formAddressField="formAddressField"
                :validateAddressField="validateAddressField"
                :onAddressFieldFocusOut="handleAddressFieldFocusOut"
                :errorMessages="errorMessages"
                :fieldsConfig="fieldsConfig"
                :getAdditionalFields="getAdditionalFields"
                :getAutocompleteLabel="getAutocompleteLabel"
                :englishAddress="englishAddress"
                :showHiddenFields="showHiddenFields"
                :hideGmapAutocomplete="hideGmapAutocomplete"

                @showHiddenFields="setHiddenFields(true)"
                @hideHiddenFields="setHiddenFields(false)"
                @manualAddressChange="onManualAddressChange"
              )
              FakturaBlock(
                v-if="fieldsConfig.ADDITIONAL_FIELDS?.length",
                :isPickPoint="activeDeliveryType?.ID === 'PICK_POINT'",
                :fields="fieldsConfig.ADDITIONAL_FIELDS" ,
                :modelValue="additionalInfo.PROFILE",
                :userInfo="userInfo",
                :profile="addressInfo.PROFILE"
                @setValidateValues="validateAdditionalField",
              @setAdditionalFieldsAsSame="setAdditionalFieldsAsSame"
            )
            MoscowDeliveryTime(
              v-if=`(positionData.CITY_NAME === 'Москва' || (lastGooglePosition && $courierMskZone(lastGooglePosition))) &&
                  (activeDeliveryType?.ID === 'COURIER') &&
                  (
                    (selectedDeliveryService === 'I_COURIER_BALANCE') ||
                      (selectedDeliveryService === 'I_M_RUNNER') ||
                      (selectedDeliveryService === 'I_COURIER_1DAY')
                    )`,
              :mkad="insideMoscowPolygon",
              :deliveryServiceId="selectedDeliveryService",
              :disable="!canStep4",
              @time="profileAddressComment = $event",
              @deliveryTime="deliveryTime = $event",
              @commentOff="profileAddressComment = ''",
              @expressDisabled="expressDisabled = $event",
              class="my-5"
            )
            SpbDeliveryTime(
              v-if=`(positionData.CITY_NAME === 'Санкт-Петербург') &&
                    (activeDeliveryType?.ID === 'COURIER') &&
                    (selectedDeliveryService === 'I_SPB_RUNNER')`,
              :mkad="insideSpbPolygon",
              :disable="!canStep4",
              @time="profileAddressComment = $event",
              @deliveryTime="deliveryTime = $event",
              @commentOff="profileAddressComment = ''",
              class="my-5"
            )
            ShippingAddress(v-if="['COURIER', 'POST'].includes(activeDeliveryType?.ID)", :profile="orderData.PROFILE")
            div(v-if="deliveryTypes.length && loading.main || loading.map")
              Skeletor(:height="600")

        .step(v-if="authed && hasCoralWalletBalance" :class="{'unactive': +step < 4}")
          //- step 4
          BonusWallet(
            @useCoralWallet="updateBasket"
            :notificationError="coralError"
          )

        //- Блок оплаты скрывается целиком, только когда заказ полностью погашен баллами CW
        .step(v-if="!isOrderFullyPaidByWallet", :class="{'unactive': !isPaymentMethodsActive}", ref="paymentStepEl")
          PaymentMethods(
            :data="paymentTypes"
            @selectMethod="onUserPickPayment($event)"
            :orderPaymentType="activePaymentType"
          )

          div(class="coral-message" v-if="coralWalletMessage && +step >= 4")
            svg(xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" fill="#EDA12F" class="coral-message-warning")
              path(fill-rule="evenodd" clip-rule="evenodd" d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.25 13.5V8.25H12.75V13.5H11.25ZM11.25 15.75V14.25H12.75V15.75H11.25Z" fill="#EDA12F")
            p(class="coral-message-text") {{$t('checkout_cw7date_notify')}}
            svg(xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" fill="#EDA12F" class="coral-message-close" @click="coralWalletMessage=false")
              path(d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#EDA12F")

        .mt-8(v-if="getCountryCode !== 'DE' || +step < 4" )
        AdditionalInfoBlock(ref="confirmationStepEl", :canSend="canSend", :buttonOnly="+step !== 4", @order="saveOrder()", @updated="updateBasket", @acceptError="coralError = $event", data-qa="checkout-additional-info-block")

      //- Божественные модалки и нотификации (в том числе Израиль)
      GodModal#cityChangeModal(
        v-if="confirmCityChangeModal",
        :height="'auto !important'",
        :width="$isMobile ? '90%' : '30%'",
        :main-content-padding="'2rem 2rem 0 2rem'",
        :overlay="true",
        :close-on-overlay-click="false",
        :close-on-button-click="true",
        :callback-functions=`{
            mainButton: 'change-current-position',
            secondaryButton: 'close-modal',
          }`,
        :button-names=`{
            mainButton: $t('switch_city_button'),
            secondaryButton: $t('cancel'),
          }`,
        :button-classes=`{
            secondaryButton: ['border-2', 'border-gray-4', 'w-full lg1024:w-1/2'],
            mainButton: ['w-full lg1024:w-1/2 mb-2 lg1024:mb-0'],
          }`,
        @change-current-position="changeCurrentPosition",
        @close-modal="closeConfirmCityChangeModal",
        data-qa="checkout-city-change-modal"
      )
        div(class="lg1024:px-8 lg1024:pt-8 pt-8 px-4")
          h3.text-xl.font-medium(class="lg1024:text-2xl") {{ $t('switch_city_from') }}
            |  {{ positionData.CITY_NAME }} {{ $t('switch_city_to') }}&nbsp;
            | {{ cityToChange.address_components.find((field) => (field.types.includes('postal_town') || field.types.includes('locality') && field.types.includes('political')) || (field.types.includes('administrative_area_level_2') && field.types.includes('political'))).long_name }}
            | ?
          p.mt-4.pb-4.text-mainColor.opacity-75 {{ $t('switch_city_description') }}

      GodModal(
        v-if="showDifferentCountryDetectorModal",
        title="",
        :height="'auto !important'",
        :width="$isMobile ? '95%' : '550px'",
        :window-class="'pb-2'",
        :main-content-padding="$isMobile ? '1rem 1rem 0 1rem' : '2rem 2rem 0 2rem'",
        :overlay="true",
        :close-on-overlay-click="true",
        :close-on-button-click="true",
        :callback-functions="{mainButton: 'close-modal'}",
        :button-names="{mainButton: $t('cancel')}",
        :button-classes="{mainButton: ['w-60']}",
        @close-position-modal="showDifferentCountryDetectorModal = false",
        @close-modal="showDifferentCountryDetectorModal = false",
        data-qa="checkout-country-detector-modal"
      )
        div(class="lg1024:px-8 lg1024:pt-8 pt-8 px-4")
          h3.text-xl.font-medium(class="lg1024:text-2xl") {{ $t('modal_delivery_no_available_title') }}
          p.mt-4.pb-4.text-mainColor.opacity-75 {{ $t('modal_delivery_no_available_text_1') }} {{ positionData.COUNTRY_NAME }} {{ $t('modal_delivery_no_available_text_2') }}

      //- Модальное окно: найден дубликат email/phone в базе ЧК
      DuplicateFoundModal(
        :modelValue="showDuplicateModal",
        :mode="duplicateModalMode",
        @confirmData="onDuplicateConfirmData",
        @makeChanges="onDuplicateMakeChanges",
        @goToAuth="goToAuth",
        data-qa="checkout-duplicate-modal"
      )

      //- Единая точка входа для модалок локальности
      LocalityModal(
        v-if="activeLocalityModal",
        v-bind="localityModalProps",
        v-on="localityModalEvents"
      )

  .saving(v-if="loading.save", data-qa="checkout-saving-overlay")
    .lds-ring
      div
      div
      div
      div
  transition(name="open-overlay")
    .overlay(v-if="authopen", data-qa="checkout-auth-overlay")

  .wrapAuthForm.flex.justify-center.items-center(v-if="authopen")
    transition(name="open-auth")
      AuthForm(v-if="authopen", @close="onClose")
  CustomsFee
</template>

<script>
import { defineAsyncComponent, markRaw, toRaw } from 'vue'
import * as Sentry from '@sentry/vue'
import {
  captureCityModalShown,
  getCheckoutContext,
  captureAutocompleteMissingFields,
  incrementCityModalCounter,
  startAddressStepTimer,
  getAddressStepTime,
  captureLongTimeOnAddressStep,
  capturePaymentTransactionFailed,
  captureOrderValidationFailed,
  extractApiError,
  captureCheckoutEvent,
} from '../utils/sentryEvents'
import { perfStart, perfEnd, perfPoint } from '../utils/perfMarks'
import { isCityInCrimeaSync } from '../utils/crimea'
import {
  trackStepViewed,
  trackPaymentMethodSelected,
  resetMethodSelectionDedup,
  trackPurchase,
  toGaItems,
} from '@/utils/checkoutAnalytics'

import { findCity } from '../global/findCity'
import { findArea } from '../global/findArea'
import { findDistrict } from '../global/findDistrict'

import GoogleMap from '../components/address/Map.vue'
import GodModal from '../components/GodModal.vue'
import DuplicateFoundModal from '../components/DuplicateFoundModal.vue'
import CustomsFee from '../components/CustomsFee.vue'
import OnboardingPopup from '../components/Onboarding/OnboardingPopup.vue'
import MoscowDeliveryTime from '../components/DeliveryTimeRU/Moscow.vue'
import SpbDeliveryTime from '../components/DeliveryTimeRU/SpbTime.vue'
import DdpBlock from '../components/DdpBlock.vue'
import FakturaBlock from '@/components/FakturaBlock.vue'
import ShippingAddress from '@/components/address/ShippingAddress.vue'
import PaymentMethods from '../components/PaymentMethods.vue'
import AdditionalInfoBlock from '../components/AdditionalInfoBlock.vue'
const LocalityModal = defineAsyncComponent(
  () => import('../components/locality/LocalityModal.vue')
)
import { formattedUSA } from '@/global/createAddress'

const AuthForm = defineAsyncComponent(
  () => import('../components/AuthForm.vue')
)
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import hideGmapAutocomplete from '@/global/mixins'
import localityCheckMixin from '@/global/localityCheckMixin'
import deliveryAnalyticsMixin from '@/global/deliveryAnalyticsMixin'
import {
  checkMaxLength,
  isProfileServiceMissing,
  resolveAvailableDelivery,
} from '@/utils/delivery'
import {
  normalizeString,
  MAX_PICKPOINT_ATTEMPTS,
  getPickpointAttempts,
  incrementPickpointAttempts,
  resetPickpointAttempts,
} from '@/utils/pickpoints'
import { getError } from '@/utils/error'
import { checkDuplicateEmailPhone } from '@/utils/userApi'
import { sendToNative } from '@/utils/nativeBridge'
import ChooseAddress from '@/steps/step0/components/profiles/ChooseAddress.vue'
import StepFio from '@/steps/step1/StepFio.vue'
import StepCity from '@/steps/step2/StepCity.vue'
import StepDeliveryType from '@/steps/step3/StepDeliveryType.vue'
import { usePostindexLookup } from '@/steps/step4/composables/usePostindexLookup'
import { isPostindexLookupCountry } from '@/utils/postindexLookup'
import ChoosePickpoints from '@/steps/step4/components/ChoosePickpoints.vue'
import PostAddress from '@/steps/step4/components/PostAddress.vue'
import CourierAddress from '@/steps/step4/components/CourierAddress.vue'
import BonusWallet from '../components/BonusWallet.vue'

import AlreadyAuthedNotice from '@/steps/step0/components/AlreadyAuthedNotice.vue'
import InfoNotice from '@/components/InfoNotice.vue'
import BannerBlock from '@/steps/step0/components/BannerBlock.vue'
import OldStep1 from '@/steps/step0/components/OldStep1.vue'
import {
  validateField,
  validateAddressField,
  getMissingAddressFields,
} from '@/utils/validation.js'
import { formatAddress, extractCourierAddressFromGoogle } from '@/utils/address'
import { validateAdditionalField } from '@/utils/additionalFIeldsValidation.js'
import {
  buildProfileUpdatePayload,
  validateProfilePayload,
} from '@/utils/profileData.js'

export default {
  name: 'CheckoutUnAuth',
  components: {
    OnboardingPopup,
    AlreadyAuthedNotice,
    BannerBlock,
    OldStep1,
    ChooseAddress,
    CustomsFee,
    BonusWallet,
    PaymentMethods,
    AdditionalInfoBlock,
    FakturaBlock,
    GoogleMap,
    GodModal,
    DuplicateFoundModal,
    LocalityModal,
    AuthForm,
    DdpBlock,
    ShippingAddress,
    MoscowDeliveryTime,
    SpbDeliveryTime,
    StepFio,
    StepCity,
    StepDeliveryType,
    ChoosePickpoints,
    PostAddress,
    CourierAddress,
    InfoNotice,
  },
  data() {
    return {
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        maxZoom: 18,
        gestureHandling: 'greedy',
        disableDefaultUI: false,
        styles: [
          {
            featureType: 'poi.business',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
        ],
      },
      plPostindexMask: ['######', '##-###'],
      moscowOutside: false,
      kyivOutside: false,
      spbOutside: false,
      showMap: false,
      authopen: false,
      step: 1,
      // useCoralWallet: false,
      checkoutData: {},
      fieldsConfig: [],
      deliveryProfiles: {},
      deliveryTime: false,
      expressDisabled: false,
      showExpressInfoRu: false,
      activePaymentType: undefined,
      activePaymentTypeName: null,
      loading: {
        main: true,
        deliveryProfiles: true,
        deliveryTypes: true,
        paymentTypes: true,
        map: false,
        save: false,
        setCity: false,
        pickpoints: false,
      },
      editMode: false,
      newProfileMode: false,
      deliveryTypes: [],
      paymentTypes: [],
      pickpoints: [],
      filteredPickpoints: [],
      filteredTypesPickpoints: [],
      activeDeliveryType: {},
      activePickpoint: null,
      googleObject: {},
      positionData: {
        AREA_NAME: null,
        CITY_NAME: null,
        COUNTRY_NAME: null,
      },
      profileAddressComment: '',
      showFaktura: false,
      formattedAddress: '',
      modalMainButtonDisabled: true,
      enteredPickpointAddress: '',
      selectedDeliveryTypes: [],
      activePickpointsTemplate: 'list',
      showSearchTools: false,
      zoomToCordsObj: {},
      selectedPickpointInfo: undefined,
      showPickpointInfoModal: false,
      confirmCityChangeModal: false,
      showDifferentCountryDetectorModal: false,
      showDuplicateModal: false,
      duplicateModalMode: 'confirm',
      duplicateField: null,
      duplicateCheckInProgress: false,
      isSecondDuplicateCheck: false,
      mustEditBeforeNextStep: false,
      addressInfo: {
        formatted: '',
        PROFILE: {},
      },
      additionalInfo: {
        formatted: '',
        PROFILE: {},
      },
      userInfo: {
        FIO: '',
        PHONE: '',
        EMAIL: '',
      },
      orderData: {},
      memberId: false,
      courierAddressMarker: {
        lat: 0,
        lng: 0,
      },
      orderValidated: false,
      cityToChange: {},
      saveError: false,
      refreshKey: 0,
      typesFilterTrigger: 0,
      showHiddenFields: false,
      insideMoscowPolygon: true,
      insideSpbPolygon: true,
      lastGooglePosition: {
        lat: 0,
        lng: 0,
      },
      coralWalletMessage: false,
      addressPopup: false,
      coralError: false,
      searchedPickpoints: [],
      searchTextPickpoints: '',
      itemsToShow: 20,
      errorMessages: {},
      stepDeliveryAutocomplete: '',
      selectedProfileId: null,
      isFioStepValid: false,
      needDefaultZoom: false,
      isProcessing: false,
      localityCheckPromise: null,
    }
  },
  async mounted() {
    perfStart('checkout:mounted')
    try {
      perfStart('checkout:fields-config')
      await this.getFieldsConfig()
      perfEnd('checkout:fields-config')

      if (this.getCountryCode !== 'RU') {
        perfStart('checkout:order-data')
        this.GET_ORDER_DATA().then(() => perfEnd('checkout:order-data'))
      }
    } catch (error) {
      perfEnd('checkout:fields-config', { report: false })
      this.addApiError(this.$store.state.deliveryError)
    }
    this.addressInfo.PROFILE = this.$store.state.addressInfo.PROFILE
    // Копируем данные из выбранного профиля в addressInfo
    if (this.$store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS) {
      const addressFio = this.$store.state.SELECTED_PROFILE.ADDRESS_INFO_FIELDS
      this.addressInfo.PROFILE = {
        ...this.addressInfo.PROFILE,
        ...addressFio,
      }
      this.addressInfo.formatted = formatAddress(addressFio)
      this._maybeReportProfilePrefilled()
    }

    if (this.getCountryCode === 'LV') {
      this.addressInfo.PROFILE.POSTINDEX = 'LV-'
    }

    if (this.fieldsConfig.ADDITIONAL_FIELDS) {
      this.additionalInfo.PROFILE =
        this.$store.state.SELECTED_PROFILE?.ADDITIONAL_INFO_FIELDS ||
        this.additionalFields()
    }

    this.loading.deliveryProfiles = false
    this.loading.deliveryTypes = false
    this.loading.paymentTypes = false
    this.loading.map = false
    this.setStepDeliveryAutocomplete()

    // для authed step = 2 уже выставлен в beforeMount — фаза «первое поле»
    // может наступить сразу здесь; для гостей сработает через watcher step
    this._reportFieldReady()
    this._maybeReportIdentReady()

    this.selectedProfileId = this.$store.state.SELECTED_PROFILE?.PROFILE_ID

    // Проверка наличия товаров при несовпадении города
    if (this.getCountryCode === 'RU') {
      perfStart('checkout:locality-check')
      this.localityCheckPromise = this.checkLocalityOnInit()
      // GET_ORDER_DATA вызовется после того, как checkLocality/changeLocality
      // вернут BasketNotUpdated (или проверка не понадобилась)
      this.localityCheckPromise.then(() => {
        perfEnd('checkout:locality-check')
        perfStart('checkout:order-data')
        this.GET_ORDER_DATA().then(() => perfEnd('checkout:order-data'))
      })
    }

    this.$nextTick(() => this._setupStepViewObservers())
  },
  created() {
    this.postindexLookup = markRaw(
      usePostindexLookup({
        getCountryCode: () => this.getCountryCode,
        getProfile: () => this.addressInfo?.PROFILE,
        getFieldsConfig: () => this.fieldsConfig,
        getErrorMessages: () => this.errorMessages,
        isPickedFromSuggest: () => this.$store.state.addressPickedFromSuggest,
        validateField: (group, field, value) =>
          this.validateField(group, field, value),
        t: (key) => this.$t(key),
        onPostindexApplied: () => this.onPostindexApplied(),
      })
    )
  },
  beforeUnmount() {
    this._teardownStepViewObservers()
  },
  mixins: [hideGmapAutocomplete, localityCheckMixin, deliveryAnalyticsMixin],
  computed: {
    ...mapState([
      'promo',
      'wallet',
      'checkoutScenario',
      'isCompany',
      'sameAddress',
      'profileMode',
      'isDeliveryLoadingWhenProfileSelected',
      'serviceState',
      'searchLocality',
    ]),
    ...mapGetters({
      isUseCoralWallet: 'wallet/isUseCoralWallet',
      isCreatingNewProfile: 'isCreatingNewProfile',
      isUpdatingProfile: 'isUpdatingProfile',
    }),
    userEditProfile() {
      return this.$store.state.checkoutScenario === 'userEditProfile'
    },
    isSelectedProfile() {
      return this.$store.state.checkoutScenario === 'isSelectedProfile'
    },
    isNewProfile() {
      return this.$store.state.checkoutScenario === 'isNewProfile'
    },
    deliveryUnavailable() {
      return isProfileServiceMissing(
        this.$store.state.SELECTED_PROFILE,
        this.deliveryTypes,
        this.positionData?.CITY_NAME
      )
    },
    ...mapGetters([
      'getCountryCode',
      'isHiddenCommentBlock',
      'isFriendOrBuyerFromFriend',
      'isBuyerFromFriend',
      'apiErrors',
      'hasApiError',
    ]),
    showEnterAddress() {
      return this.$checkoutOptions?.showEnterAddress
    },
    activeLocalityModal() {
      return (
        this.localityCheck.showCityConfirm ||
        this.localityCheck.showUnavailable ||
        this.localityCheck.showEmptyBasket
      )
    },
    localityModalProps() {
      if (this.localityCheck.showCityConfirm) {
        return {
          modelValue: true,
          title: this.$t('locality_check_title'),
          description: this.$t('locality_check_description')
            .replace('{headerCity}', this.localityCheck.headerCity)
            .replace('{profileCity}', this.localityCheck.profileCity),
          callbackFunctions: {
            mainButton: 'choose-header-city',
            secondaryButton: 'choose-profile-city',
          },
          buttonNames: {
            mainButton: this.$t('locality_check_header_city_btn'),
            secondaryButton: this.$t('locality_check_profile_city_btn'),
          },
          buttonClasses: {
            mainButton: [
              'sm640:order-2 w-full sm640:w-auto mb-2 sm640:mb-0 sm640:ml-8',
            ],
            secondaryButton: ['sm640:order-1 w-full sm640:w-auto sm640:!ml-0'],
          },
        }
      }
      if (this.localityCheck.showUnavailable) {
        return {
          modelValue: true,
          title: this.$t('locality_unavailable_title'),
          description: this.$t('locality_unavailable_description'),
          items: this.localityCheck.unavailableItems,
          callbackFunctions: {
            mainButton: 'continue',
            secondaryButton: 'check-basket',
          },
          buttonNames: {
            mainButton: this.$t('locality_unavailable_continue'),
            secondaryButton: this.$t('locality_unavailable_check_basket'),
          },
          buttonClasses: {
            mainButton: [
              'sm640:order-2 w-full sm640:w-auto mb-2 sm640:mb-0 sm640:ml-8',
            ],
            secondaryButton: ['sm640:order-1 w-full sm640:w-auto sm640:!ml-0'],
          },
        }
      }
      if (this.localityCheck.showEmptyBasket) {
        // TODO: делаем changeLocality и просто редиректим
        return {
          modelValue: true,
          title: this.$t('locality_empty_title'),
          description: this.$t('locality_empty_description'),
          callbackFunctions: {
            mainButton: 'go-to-catalog',
          },
          buttonNames: {
            mainButton: this.$t('locality_empty_go_catalog'),
          },
          buttonClasses: {
            mainButton: ['w-full lg1024:w-1/2 ml-auto'],
          },
        }
      }
      return {}
    },
    localityModalEvents() {
      if (this.localityCheck.showCityConfirm) {
        return {
          'choose-header-city': this.handleChooseHeaderCity,
          'choose-profile-city': this.handleChooseProfileCity,
          'close-modal': this.handleChooseHeaderCity,
        }
      }
      if (this.localityCheck.showUnavailable) {
        return {
          continue: this.handleContinueWithUnavailable,
          'check-basket': this.handleCheckBasket,
          'close-modal': this.handleContinueWithUnavailable,
        }
      }
      if (this.localityCheck.showEmptyBasket) {
        return {
          'go-to-catalog': this.handleGoToCatalog,
          'close-modal': this.handleGoToCatalog,
        }
      }
      return {}
    },
    countryRestriction() {
      let country = this.getCountry.code
      if (this.getCountry.code === 'RO') country = [this.getCountry.code, 'MD']
      if (this.getCountry.code === 'US')
        country = [this.getCountry.code, 'VI', 'PR']
      if (this.getCountry.code === 'GB') country = [this.getCountry.code, 'IM']
      return country
    },
    selectedDeliveryService() {
      return this.$store.state.selectedDeliveryTypeService?.ID
        ? this.$store.state.selectedDeliveryTypeService?.ID
        : this.$store.state.selectedDeliveryTypeService
    },
    dutyEnabled: {
      get() {
        return this.$store.state.dutyEnabled
      },
      set(nv) {
        this.$store.commit('dutyEnabled', nv)
        this.updateBasket()
      },
    },
    authed() {
      return window.authed
    },
    uid() {
      return window.uid
    },
    typesFilter() {
      this.typesFilterTrigger
      if (
        this.$store.state.pickpoints[this.positionData.CITY_NAME]?.length > 0
      ) {
        const types = [
          ...new Set(
            this.$store.state.pickpoints[this.positionData.CITY_NAME].map(
              (v) => v.TYPE
            )
          ),
        ]
        return types
      } else {
        return []
      }
    },
    // проверка на выбор типа доставки и заполнение полей адреса
    canStep4() {
      let r = true
      r = this.isFioStepValid
      this.refreshKey // интересная строчка )))

      if (this.fieldsConfig.ADDITIONAL_FIELDS) {
        this.fieldsConfig.ADDITIONAL_FIELDS.forEach((item) => {
          if (item.required && item.visual && item.type === 'text') {
            r = Boolean(
              r &&
              this.additionalInfo.PROFILE[item.name] &&
              this.additionalInfo.PROFILE[item.name]?.trim().length > 0
            )
          }
        })
      }

      if (this.activeDeliveryType?.ID == 'PICK_POINT') {
        r = r && Boolean(this.selectedPickpointInfo)
      } else {
        if (Object.keys(this.addressInfo.PROFILE).length === 0) {
          return false
        }
        if (this.fieldsConfig.ADDRESS_INFO_FIELDS) {
          for (const item of this.fieldsConfig.ADDRESS_INFO_FIELDS) {
            if (
              item.required &&
              item.type === 'text' &&
              !['FIO', 'PHONE', 'EMAIL'].includes(item.name)
            ) {
              if (typeof this.addressInfo.PROFILE[item.name] === 'undefined')
                return false

              const validFieldLength =
                this.getCountryCode === 'LV' && item.name === 'POSTINDEX'
                  ? 6
                  : 0
              if (
                Boolean(r) &&
                this.addressInfo.PROFILE[item.name] !== null &&
                this.addressInfo.PROFILE[item.name]?.trim() &&
                this.addressInfo.PROFILE[item.name]?.trim().length >
                  validFieldLength
              ) {
                r = Boolean(
                  r &&
                  this.addressInfo.PROFILE[item.name]?.trim() &&
                  this.addressInfo.PROFILE[item.name]?.trim().length > 0
                )
              } else {
                return false
              }
            }
          }
        } else {
          return false
        }
      }
      return Boolean(r)
    },
    orderTotal() {
      return Number(this.$store.state.orderData.TOTAL_PRICE)
    },
    isOrderFullyPaidByWallet() {
      return Boolean(this.isUseCoralWallet) && this.orderTotal === 0
    },
    hasCoralWalletBalance() {
      return Number(this.wallet?.CW_VALUE) > 0
    },
    ilMaxPrice() {
      return Boolean(
        this.getCountryCode === 'IL' &&
        this.orderTotal >= 3500 &&
        this.$store.state.IS_COUNTRY_GLOBAL
      )
    },
    canSend() {
      const reasons = {}

      // 1. лимит по стоимости для IL
      reasons.ilMaxPrice = !this.ilMaxPrice // true  → ОК
      // 2. есть MemberId или авторизован
      // reasons.isUserKnown =
      //   this.$store.state.memberId !== false || this.$store.state.authed
      // 3. выбрана оплата. При полном погашении баллами CW блок способов оплаты
      // скрыт — выбирать нечего, поэтому требование снимается.
      reasons.paymentChosen =
        this.isOrderFullyPaidByWallet || this.activePaymentType !== undefined
      // 3.1. нет ожидания исправления дубликата
      reasons.noDuplicateBlock = !this.mustEditBeforeNextStep
      // 4. заполнены FIO/PHONE/EMAIL
      reasons.userInfoFilled =
        !!this.userInfo?.FIO?.length &&
        !!this.userInfo?.PHONE?.length &&
        !!this.userInfo?.EMAIL?.length
      // 5. проверка ФИО с одним полем «одно слово»
      const fio = this.orderData?.FIO?.replace(/undefined/i, '').trim() ?? ''
      reasons.fioHasTwoWords = fio.split(' ').length >= 2
      // 6. достав-ка = ПВЗ ⇒ выбран pick-point
      if (this.activeDeliveryType?.ID === 'PICK_POINT') {
        reasons.pickpointChosen = !!this.selectedPickpointInfo
      } else {
        // 7. обязательные поля ADDRESS_INFO_FIELDS/ADDITIONAL_FIELDS
        reasons.addressFieldsOk = this._checkAddressFields
      }

      // ✅ итог
      const allOk = Object.values(reasons).every(Boolean)

      // выводим только «провалившиеся» пункты
      // if (!allOk) {
      //   console.table(
      //     Object.entries(reasons).map(([k, v]) => ({ check: k, passed: v }))
      //   )
      // }
      return allOk
    },

    /* вспомогательная проверка адреса */
    _checkAddressFields() {
      if (this.activeDeliveryType?.ID !== 'PICK_POINT') {
        if (!this.fieldsConfig?.ADDRESS_INFO_FIELDS) return false

        // ADDITIONAL_FIELDS
        if (this.fieldsConfig.ADDITIONAL_FIELDS) {
          for (const item of this.fieldsConfig.ADDITIONAL_FIELDS) {
            if (
              item.required &&
              item.visual &&
              item.type === 'text' &&
              !this.additionalInfo.PROFILE[item.name]?.trim()?.length
            ) {
              console.warn('❌ additional field', item.name)
              return false
            }
          }
        }

        // основные поля адреса
        for (const item of this.fieldsConfig.ADDRESS_INFO_FIELDS) {
          if (
            item.required &&
            item.type === 'text' &&
            !['FIO', 'PHONE', 'EMAIL'].includes(item.name)
          ) {
            const val = this.addressInfo.PROFILE[item.name]?.trim()
            if (!val?.length) {
              console.warn('❌ address field', item.name)
              return false
            }
          }
        }
        return true
      }
      return false
    },

    getCountry() {
      return this.$store.state.country
    },
    getCurrency() {
      return this.$store.state.currency
    },
    actualPickpointsFilter() {
      return this.filteredPickpoints.length
        ? this.filteredPickpoints
        : this.pickpoints
    },
    modalMainButtonDisabledState() {
      return this.modalMainButtonDisabled
    },
    titleDeliveryTypes() {
      return this.deliveryTypes?.length === 1
        ? this.deliveryTypes[0].NAME
        : this.$t('choose_delivery_type')
    },
    selectedPosition() {
      return this.formattedAddress
    },
    getDeliveryCompaniesList() {
      return this.$store.state.deliveryCompanies
    },
    isKR() {
      return this.getCountry.code === 'KR'
    },
    isUSPanregion() {
      return ['US', 'CA'].includes(this.getCountry.code)
    },
    englishAddress() {
      return ['US', 'CA', 'GB'].includes(this.getCountry.code)
    },
    getAllPickpoints() {
      const pickpoints =
        this.searchTextPickpoints?.length > 0
          ? this.searchedPickpoints
          : this.filteredTypesPickpoints.length > 0
            ? this.filteredPickpoints
            : this.$store.state.pickpoints[this.positionData.CITY_NAME]
      return pickpoints
    },
    getAutocompleteLabel() {
      return this.$t('delivery_address_label')
    },
    getAdditionalFields() {
      const fieldsConfig = this.fieldsConfig.ADDRESS_INFO_FIELDS
      if (Array.isArray(fieldsConfig)) {
        if (this.getCountry.code === 'RU') {
          return fieldsConfig.filter(
            (field) =>
              !['FLOOR', 'ENTRANCE', 'INTERCOM', 'CORPUS'].includes(field.name)
          )
        }
        return fieldsConfig
      }
      return []
    },
    // автоматический выбор доставки из последнего профиля
    lastServiceId() {
      const lastDeliveryType =
        this.$store.state.SELECTED_PROFILE?.LAST_CHOICES?.LAST_DELIVERY_TYPE
          ?.SERVICE?.ID
      return lastDeliveryType || ''
    },
    lastPickpointCode() {
      const lastPickpoint =
        this.$store.state.SELECTED_PROFILE?.LAST_CHOICES?.LAST_DELIVERY_TYPE
          ?.SERVICE?.PICKPOINT
      if (lastPickpoint) return lastPickpoint
      return ''
    },
    gMapAutocompleteTypes() {
      return this.getCountryCode === 'US' ? [] : ['(cities)']
    },
    // Блок «Способы оплаты» доступен сразу после заполнения способа получения.
    // Coral Wallet больше НЕ гейтит оплату: оба блока открываются одновременно.
    isPaymentMethodsActive() {
      return this.step >= 4
    },
  },
  watch: {
    async selectedProfileId(nv) {
      this.setIsDeliveryLoadingWhenProfileSelected(true)
      if (!nv) return

      // новый профиль — разрешаем эмит delivery/payment_method_selected заново
      this._paymentReported = null
      resetMethodSelectionDedup()
      this.resetAddressAnalytics()
      // сброс fired-флагов: step_viewed должен перестрелить для нового профиля
      if (this._stepViewState) {
        Object.values(this._stepViewState).forEach((s) => {
          s.fired = false
        })
      }

      // 1) найти объект профиля в store
      const profile = this.$store.getters.getProfile(nv)
      if (!profile) return

      if (this.fieldsConfig.ADDITIONAL_FIELDS) {
        this.additionalInfo.PROFILE = profile.ADDITIONAL_INFO_FIELDS
      }
      this.$store.commit('UpdateSelectedProfile', profile)
      this.setAdditionalFielads(
        profile.ADDITIONAL_INFO_FIELDS,
        profile.ADDITIONAL_INFO_FIELDS?.IS_COMPANY
      )
      const addressFio = profile.ADDRESS_INFO_FIELDS

      // Для RU: если город профиля отличается от текущего — проверяем наличие товаров
      const oldCity = this.positionData.CITY_NAME
      const newCity = addressFio.CITY
      const newArea = addressFio.AREA || ''
      let cityChangedNeedsDelivery = false
      if (
        this.getCountryCode === 'RU' &&
        oldCity &&
        newCity &&
        oldCity !== newCity
      ) {
        const result = await this.checkLocalityFlow(
          newCity,
          newArea,
          'profileChange'
        )
        // BasketUpdated / BasketClear — модалка покажется из checkLocalityFlow,
        // не обновляем данные профиля до подтверждения пользователем
        if (result !== 'no_change') {
          this.lockNewProfileBtn()
          return
        }
        cityChangedNeedsDelivery = true
      }

      // StepFio
      this.userInfo = {
        FIO: addressFio.FIO,
        PHONE: addressFio.PHONE,
        EMAIL: addressFio.EMAIL,
      }

      // StepCity
      this.positionData.AREA_NAME = addressFio.AREA
      this.positionData.CITY_NAME = addressFio.CITY
      this.positionData.COUNTRY_NAME = addressFio.COUNTRY

      // CourierAddress, PostAddress
      this.addressInfo.PROFILE = { ...addressFio }
      this.addressInfo.formatted = formatAddress(addressFio)
      this._maybeReportProfilePrefilled()
      // StepDeliveryType
      this.applyProfileDelivery(profile)

      this.reportDeliveryPrefill(this.activeDeliveryType?.ID)
      // Сброс промокода при изменении профиля (wallet сбросится автоматически через watcher в BonusWallet)
      this.$store.commit('toggleServiceState', !this.serviceState)

      // Город профиля отличается — перезапрашиваем /delivery для нового города,
      // чтобы типы/цены/deliveryCompanies и список ПВЗ соответствовали выбранному городу
      if (cityChangedNeedsDelivery) {
        await this.getDeliveryTypes()
      }

      this.lockNewProfileBtn()
    },
    // Срабатывает, когда /delivery обновился (вход в чекаут, смена города).
    // Если сохранённый в профиле сервис (LAST_CHOICES.SERVICE.ID) отсутствует
    // в новом ответе — переприменяем fallback. Интерактивную смену профиля
    // отрабатывает watcher selectedProfileId → applyProfileDelivery.
    deliveryTypes(nv) {
      // пользовательская фаза 8 «способы доставки отобразились»
      this._maybeReportDeliveryTypesVisible()
      if (!nv?.length) return
      if (!this.deliveryUnavailable) return
      this.applyProfileDelivery(this.$store.state.SELECTED_PROFILE)
    },
    showHiddenFields(nv) {
      // сбросить ошибку валидации адреса при переключении режима
      this.setCourierAddressFieldError(false)

      if (nv) {
        // при переходе в ручной режим — заполнить скрытые поля (CITY, AREA, COUNTRY)
        // из positionData, чтобы валидация не ругалась на незаполненные обязательные поля
        if (!this.addressInfo.PROFILE.CITY) {
          this.addressInfo.PROFILE.CITY = this.positionData.CITY_NAME
        }
        if (!this.addressInfo.PROFILE.AREA) {
          this.addressInfo.PROFILE.AREA = this.positionData.AREA_NAME
        }
        if (!this.addressInfo.PROFILE.COUNTRY) {
          this.addressInfo.PROFILE.COUNTRY = this.positionData.COUNTRY_CODE
        }
        if (!this.addressInfo.PROFILE.COUNTRY_NAME) {
          this.addressInfo.PROFILE.COUNTRY_NAME = this.positionData.COUNTRY_NAME
        }
      } else {
        // сбросить все поля адреса, если стэйт меняется с ручного введения на поиск по карте
        const skip = ['COUNTRY', 'COUNTRY_CODE', 'COUNTRY_NAME', 'CITY', 'AREA']
        for (const key in this.orderData.PROFILE) {
          if (!skip.includes(key)) {
            this.addressInfo.PROFILE[key] = null
            this.orderData.PROFILE[key] = null
          }
        }
      }

      // валидируем поля адреса при изменении режима ввода, чтобы показать ошибки при пустых полей
      for (const field of this.fieldsConfig?.ADDRESS_INFO_FIELDS || []) {
        if (
          field.type === 'text' &&
          !['FIO', 'PHONE', 'EMAIL'].includes(field.name)
        ) {
          this.validateField(
            'ADDRESS_INFO_FIELDS',
            field.name,
            this.addressInfo.PROFILE[field.name]
          )
        }
      }
    },
    addressInfo: {
      handler() {
        // TODO: проверить и сравнить этот функционал с функционалом Гуго для Италии (удаление символов в адресе)
        if (Object.keys(this.addressInfo).length === 0) return
        for (const key in this.addressInfo.PROFILE) {
          if (!['COUNTRY', 'COUNTRY_CODE', 'COUNTRY_NAME'].includes(key)) {
            this.addressInfo.PROFILE[key] = this.removeSymbols(
              this.addressInfo.PROFILE[key]
            )
          }
        }

        let addressInfo = JSON.parse(JSON.stringify(this.addressInfo))
        if (this.showFaktura) {
          addressInfo.PROFILE = Object.assign(
            {},
            addressInfo.PROFILE,
            this.additionalInfo.PROFILE
          )
        }
        this.orderData = { ...this.userInfo, ...addressInfo }
        if ('formatted' in this.orderData) {
          delete this.orderData.formatted
        }
        this.refreshKey++
        this.$store.commit('updateAddressInfo', this.addressInfo)
      },
      deep: true,
    },
    cityToChange(nv) {
      if (!nv || !nv.address_components || !this.isSelectedProfile) return

      const oldCity = this.positionData.CITY_NAME || 'Неизвестно'
      const newCityObj = findCity(nv, this.getCountryCode)
      const newCity = newCityObj?.long_name || 'Неизвестно'
      Sentry.withScope((scope) => {
        // Задаём жесткий отпечаток. Все события с ним склеятся в ровно одну issue.
        scope.setFingerprint(['checkout-city-change-detector'])
        scope.setTag('city_old', oldCity)
        scope.setTag('city_new', newCity)
        scope.setExtra('google_object', nv)
        Sentry.captureMessage(
          `City changed from ${oldCity} to ${newCity}`,
          'info'
        )
      })
    },
    additionalInfo: {
      handler() {
        let addressInfo = JSON.parse(JSON.stringify(this.addressInfo))
        if (this.showFaktura) {
          addressInfo.PROFILE = Object.assign(
            {},
            addressInfo.PROFILE,
            this.additionalInfo.PROFILE
          )
        }
        this.orderData = { ...this.userInfo, ...addressInfo }
        if ('formatted' in this.orderData) {
          delete this.orderData.formatted
        }
        this.refreshKey++
      },
      deep: true,
    },
    userInfo: {
      handler() {
        let addressInfo = JSON.parse(JSON.stringify(this.addressInfo))
        if (this.showFaktura) {
          addressInfo.PROFILE = Object.assign(
            {},
            addressInfo.PROFILE,
            this.additionalInfo.PROFILE
          )
        }
        this.orderData = { ...this.userInfo, ...addressInfo }
      },
      deep: true,
    },
    memberId() {
      if (this.memberId !== false) {
        this.step = this.isFioStepValid ? 3 : 2
      } else {
        this.step = 1
      }
    },
    isFioStepValid(canInputCity) {
      if (canInputCity) {
        this.step = this.canStep4 ? 4 : 3
      } else {
        this.step = 2
      }
    },
    async canStep4(nv) {
      if (nv) {
        this.step = 4
        await this.updateBasket()
      } else {
        this.step = this.isFioStepValid ? 3 : 2
      }
    },
    // race: блок мог уже быть в viewport, пока был disabled
    isPaymentMethodsActive(nv) {
      if (nv) this._maybeFireStepView('payment')
    },
    wallet() {
      if (this.wallet.CW_VALUE && new Date().getDate() === 7) {
        this.coralWalletMessage = true
      }
    },
    expressDisabled() {
      if (this.expressDisabled) {
        this.deliveryTypes.forEach((deliveryType) => {
          if (deliveryType.ID === 'COURIER') {
            deliveryType.ITEMS = deliveryType.ITEMS.filter(
              (item) => item.ID !== 'I_COURIER_1DAY'
            )
          }
        })
        this.showExpressInfoRu = true
      }
    },
    'addressInfo.PROFILE.BUILD': {
      handler(value) {
        if (
          this.getCountry?.code === 'IT' &&
          this.fieldsConfig?.ADDRESS_INFO_FIELDS
        ) {
          let maxLength = this.fieldsConfig?.ADDRESS_INFO_FIELDS.filter(
            (el) => el.name === 'BUILD'
          )
          if (maxLength.length > 0 && maxLength[0]?.max) {
            this.addressInfo.PROFILE.BUILD = value?.slice(
              0,
              toRaw(maxLength[0]).max
            )
          }
        }
      },
    },
    'addressInfo.PROFILE.POSTINDEX': {
      handler(value, oldValue) {
        if (this.getCountryCode !== 'ES' || !value || value === oldValue) return

        this.fetchOrderDataOnPostIndexChange()
      },
    },
    // Таймер для шага адреса (step 4)
    step(newStep, oldStep) {
      // пользовательские фазы: ФИО-шаг и шаг адреса стали активны (одноразово)
      this._reportFieldReady()
      this._maybeReportAddressReady()

      // IO стреляет только при *изменении* видимости блока. Если блок уже
      // был в viewport, когда active()-гейт открылся — IO не перестрелит.
      if (+newStep >= 3) this._maybeFireStepView('delivery')
      if (+newStep >= 4) this._maybeFireStepView('confirmation')

      // Запускаем таймер при переходе на шаг адреса
      if (newStep === 4 && oldStep < 4) {
        startAddressStepTimer()
      }
      // Отправляем событие при уходе с шага адреса (на оплату)
      if (newStep > 4 && oldStep === 4) {
        const timeSpent = getAddressStepTime()
        if (timeSpent > 0) {
          captureLongTimeOnAddressStep({
            context: getCheckoutContext(this.$store),
            timeSpentSec: timeSpent,
          })
        }
      }
    },
    // RU: пока идёт проверка locality, автокомплит города заблокирован —
    // фаза «адрес доступен» наступает только после разблокировки
    'localityCheck.cityFieldLocked'() {
      this._maybeReportAddressReady()
    },
    paymentTypes() {
      this._maybeReportPaymentVisible()
    },
    hasCoralWalletBalance(nv) {
      if (nv) this._maybeReportWalletVisible()
    },
  },
  beforeMount() {
    if (this.authed) this.step = 2
    this.lockNewProfileBtn()

    if (
      !this.$store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS &&
      this.$store.state.user
    ) {
      const user = this.$store.state.user
      this.userInfo = {
        // Проверка по latinOnly: регистрация в RU → вход в US → первый заход в чекаут.
        FIO: this.isFioPrefillAllowed(user.FIO) ? user.FIO : '',
        PHONE: user.PHONE || '',
        EMAIL: user.EMAIL || '',
      }
    }
  },
  methods: {
    ...mapActions(['GET_ORDER_DATA']),
    ...mapMutations([
      'setIsCompany',
      'setAddressAsSame',
      'UpdateSelectedProfile',
      'setProfileMode',
      'updateFieldsRequirement',
      'setIsDeliveryLoadingWhenProfileSelected',
      'addApiError',
      'setApiErrors',
      'resetApiErrors',
      'setCourierAddressFieldError',
    ]),
    isFioPrefillAllowed(fio) {
      if (!fio) return false
      if (!this.$latinOnly) return true
      return fio.replace(this.$latinRegex, '') === fio
    },

    // ── Пользовательские фазы загрузки (точки от открытия страницы) ──
    // Одноразовые: локальный флаг + дедуп внутри perfPoint.

    // Фаза «первое поле чекаута доступно для ввода»: ФИО-шаг активен.
    // Для authed шаг = 2 ставится в beforeMount, для гостей приходит
    // в watcher'е memberId → step, поэтому зовём и из mounted, и из watcher'а.
    _reportFieldReady() {
      if (this._fieldReadyReported) return
      if (+this.step < 2 && !this.isFriendOrBuyerFromFriend) return
      this._fieldReadyReported = true
      this.$nextTick(() => perfPoint('ui:first-field-ready'))
    },

    _maybeReportIdentReady() {
      if (this._identReadyReported) return
      if (this.authed || this.isFriendOrBuyerFromFriend) return
      if (this.$initError) return
      this._identReadyReported = true
      this.$nextTick(() => perfPoint('ui:ident-ready'))
    },

    // Фаза «блок адреса доступен для ввода»: шаг адреса активен и
    // автокомплит города не заблокирован RU-проверкой locality.
    _maybeReportAddressReady() {
      if (this._addressReadyReported) return
      if (+this.step < 3) return
      if (this.localityCheck.cityFieldLocked) return
      this._addressReadyReported = true
      this.$nextTick(() => perfPoint('ui:address-ready'))
    },

    _maybeReportDeliveryTypesVisible() {
      if (this._deliveryTypesVisibleReported) return
      if (!this.deliveryTypes.length || this.loading.main) return
      this._deliveryTypesVisibleReported = true
      this.$nextTick(() => perfPoint('ui:delivery-types-visible'))
    },

    _maybeReportPaymentVisible() {
      if (this._paymentVisibleReported) return
      if (!this.paymentTypes.length || this.loading.main) return
      this._paymentVisibleReported = true
      this.$nextTick(() => perfPoint('ui:payment-visible'))
    },

    _maybeReportWalletVisible() {
      if (this._walletVisibleReported) return
      if (!this.authed || !this.hasCoralWalletBalance || this.loading.main)
        return
      this._walletVisibleReported = true
      this.$nextTick(() => perfPoint('ui:wallet-visible'))
    },

    _maybeReportProfilePrefilled() {
      if (this._profilePrefillReported) return
      this._profilePrefillReported = true
      this.$nextTick(() => perfPoint('ui:profile-prefilled'))
    },

    _setupStepViewObservers() {
      // active() гейтит step_viewed по реально достигнутому шагу, а не только
      // по видимости блока: на высоких экранах несколько блоков видны
      // одновременно, и без привязки к this.step delivery/confirmation летели
      // бы пачкой вместе с текущим шагом («фантомные шаги»). (bug #3)
      this._stepViewState = {
        delivery: {
          fired: false,
          inView: false,
          active: () => +this.step >= 3,
        },
        payment: {
          fired: false,
          inView: false,
          active: () => this.isPaymentMethodsActive,
        },
        confirmation: {
          fired: false,
          inView: false,
          active: () => +this.step >= 4,
        },
      }

      // блок виден ≥80%: либо 80% площади блока, либо блок занимает 80%
      // viewport (для блоков выше экрана — там intersectionRatio < 1)
      const VIEW_RATIO = 0.8
      const isStepVisible = (entry) => {
        if (!entry || !entry.isIntersecting) return false
        if (entry.intersectionRatio >= VIEW_RATIO) return true
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight || 0
        if (!viewportHeight) return false
        return entry.intersectionRect.height / viewportHeight >= VIEW_RATIO
      }

      // густой шаг — для блоков выше viewport ratio упирается в потолок V/H,
      // нужны частые tick'и чтобы OR-проверка успела сработать
      const thresholds = Array.from({ length: 101 }, (_, i) => i / 100)

      const observe = (key, el) => {
        if (!el || typeof IntersectionObserver === 'undefined') return null
        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[entries.length - 1]
            if (!entry) return
            const visible = isStepVisible(entry)
            this._stepViewState[key].inView = visible
            if (visible) this._maybeFireStepView(key)
          },
          { threshold: thresholds }
        )
        observer.observe(el)
        return observer
      }

      const confirmationRef = this.$refs.confirmationStepEl
      const confirmationEl = confirmationRef?.$el || confirmationRef
      this._stepViewObservers = [
        observe('delivery', this.$refs.deliveryStepEl),
        observe('payment', this.$refs.paymentStepEl),
        observe('confirmation', confirmationEl),
      ]
    },
    _teardownStepViewObservers() {
      this._stepViewObservers?.forEach((o) => o?.disconnect())
      this._stepViewObservers = null
    },
    _maybeFireStepView(key) {
      const state = this._stepViewState?.[key]
      if (!state || state.fired || !state.inView || !state.active()) return

      // Порядок воронки: confirmation НИКОГДА не отправляется раньше payment.
      if (key === 'confirmation') {
        const payment = this._stepViewState.payment
        if (payment && !payment.fired) {
          this._fireStepView('payment')
        }
      }

      this._fireStepView(key)
    },

    // Фактическая отправка checkout_step_viewed. Гейты (inView/active/порядок)
    _fireStepView(key) {
      const state = this._stepViewState?.[key]
      if (!state || state.fired) return
      state.fired = true
      trackStepViewed({
        step: key,
        totalValue: this.$store.state.orderData.FULL_PRICE,
        deliveryMethod: this.activeDeliveryType?.ID,
        paymentMethod: this.activePaymentTypeName || null,
      })
      // payment_method_selected летит вместе со step_viewed для payment.
      // Дедуп по уже отправленному методу: prefill и ручной выбор не должны
      // эмитить одно и то же значение дважды с разными source. (bug #2)
      if (
        key === 'payment' &&
        this.activePaymentTypeName &&
        this._paymentReported !== this.activePaymentTypeName
      ) {
        trackPaymentMethodSelected({
          source: 'prefill',
          trigger: 'auto_prefill',
          method: this.activePaymentTypeName,
        })
        this._paymentReported = this.activePaymentTypeName
      }
    },

    async onUserPickPayment(event) {
      const id = event?.ID
      const name = event?.NAME
      await this.setActivePaymentMethod(id, name)
      // дедуп по уже отправленному методу (см. bug #2)
      if (name && this._paymentReported !== name) {
        trackPaymentMethodSelected({
          source: 'manual_input',
          trigger: 'user_action',
          method: name,
        })
        this._paymentReported = name
      }
    },

    async changeCurrentPosition() {
      this.confirmCityChangeModal = false

      // После подтверждения смены города — проверяем наличие товаров
      const { pendingCity, pendingArea } = this.localityCheck
      if (this.getCountryCode === 'RU' && pendingCity) {
        const result = await this.checkLocalityFlow(
          pendingCity,
          pendingArea,
          'addressChange'
        )
        this.localityCheck.pendingCity = ''
        this.localityCheck.pendingArea = ''
        if (result !== 'no_change') return
      }

      const addressPatch = extractCourierAddressFromGoogle(
        this.cityToChange,
        this.getCountryCode
      )

      this.localityCheck.addressFieldLocked = true
      try {
        // Восстановление адреса строго ПОСЛЕ await: formPositionData делает
        // clearAddress() и await getDeliveryTypes/getPaymentTypes
        await this.formPositionData(this.cityToChange)
        this.applyCourierAddressPatch(addressPatch)
        this.cityToChange = {}
      } finally {
        this.localityCheck.addressFieldLocked = false
      }
    },

    // Пишет извлечённые адресные поля в addressInfo.
    applyCourierAddressPatch(patch) {
      if (!patch) return

      this.addressInfo.formatted = patch.formatted
      this.addressInfo.PROFILE[patch.streetKey] = patch.streetValue

      // Не затираем существующий номер дома, если Google его не нашёл.
      if (patch.buildValue !== null) {
        this.addressInfo.PROFILE[patch.buildKey] = patch.buildValue
      }

      if (patch.postindex !== null) {
        this.addressInfo.PROFILE.POSTINDEX = patch.postindex
        this.validateField(
          'ADDRESS_INFO_FIELDS',
          'POSTINDEX',
          this.addressInfo.PROFILE.POSTINDEX
        )
      }

      if (patch.marker) {
        this.courierAddressMarker.lat = patch.marker.lat
        this.courierAddressMarker.lng = patch.marker.lng
        this.setMapCordsForZoom(this.courierAddressMarker)
      }
    },

    async fetchOrderDataOnPostIndexChange() {
      await this.$store.dispatch('GET_ORDER_DATA', {
        deliveryId: this.selectedDeliveryService,
        paymentId: this.activePaymentType,
        positionData: this.positionData,
        profile: { ...this.addressInfo.PROFILE },
      })
    },

    setAdditionalFielads(additionalFields, isCompany = false) {
      this.additionalInfo.PROFILE = additionalFields || this.additionalFields()
      this.setIsCompany(isCompany)
      this.setAddressAsSame(false)
      this.updateFieldsRequirement()
    },

    updateDeliveryType(delivery) {
      if (delivery.ID === 'PICK_POINT' && this.getCountryCode === 'PL') {
        this.setAdditionalFielads()
      }
    },
    additionalFields() {
      if (!this.fieldsConfig.ADDITIONAL_FIELDS) {
        return {}
      }

      const additionalFields = Object.fromEntries(
        this.fieldsConfig.ADDITIONAL_FIELDS.map((field) => [field.name, ''])
      )

      return additionalFields
    },
    validateAdditionalField(group, field, value) {
      validateAdditionalField(
        group,
        field,
        value,
        this.getCountryCode,
        this.$t,
        this.fieldsConfig,
        this.getFieldPropertyValue,
        this.additionalInfo.PROFILE
      )
    },

    validateField(group, field, value) {
      validateField(
        group,
        field,
        value,
        this.getCountryCode,
        this.addressInfo,
        this.$t,
        this.fieldsConfig,
        this.getFieldPropertyValue
      )
    },
    validateAddressField(value, fromGMap) {
      validateAddressField(
        value,
        fromGMap,
        this.addressInfo,
        this.fieldsConfig,
        this.$t
      )
    },
    setAdditionalFieldsAsSame(field) {
      const buildNum =
        this.addressInfo.PROFILE.BUILD_APART_NUM ||
        this.userInfo.BUILD_APART_NUM
      if (this.sameAddress) {
        this.additionalInfo.PROFILE[field] =
          this.addressInfo.PROFILE[field.slice(8)] ||
          this.userInfo[field.slice(8)]

        if (field === 'FAKTURA_ADDRESS') {
          this.additionalInfo.PROFILE[field] += `, ${buildNum}`
        }

        this.validateAdditionalField(
          'ADDITIONAL_FIELDS',
          field,
          this.additionalInfo.PROFILE[field]
        )
      } else {
        this.additionalInfo.PROFILE[field] = ''
      }
    },
    editScenario() {
      this.$store.commit('setCheckoutScenario', 'userEditProfile')
    },
    setHiddenFields(show) {
      this.showMap = false
      this.showHiddenFields = show
      window.addressManual = show
    },
    removeSymbols(value) {
      if (!value) return value
      // no cyr
      if (value && value !== null && this.$noCyrSymbols && value.length > 0) {
        value = value
          .split('')
          .filter((char) => !this.$cyrLetters.includes(char))
          .join('')
      }
      //latin only
      if (value !== null && this.$latinOnly && value.length > 0) {
        value = value.replace(this.$latinRegex, '')
      }

      return value
    },
    formatMoney(value) {
      return new Intl.NumberFormat(this.getCountryCode, {
        style: 'currency',
        currency: this.$store.state.currency,
        currencyDisplay: this.getCountryCode === 'NO' ? 'code' : 'symbol',
        numberingSystem: 'latn',
      }).format(value ?? 0)
    },
    updateFioFields(event) {
      this.userInfo = { ...this.userInfo, ...event }
    },
    activePickpointAddressModal(activePickpoint) {
      return (
        (!activePickpoint.ADDRESS.includes(activePickpoint.CITY) &&
        activePickpoint.TYPE !== 'I_UA_NEW_POST'
          ? activePickpoint.CITY + ',&nbsp;'
          : '') +
        activePickpoint.ADDRESS.replace(/<\/?[^>]+(>|$)/g, ' ') +
        '&nbsp;'
      )
    },
    async updateBasket() {
      const profile = JSON.parse(JSON.stringify(this.orderData.PROFILE))
      if (typeof profile.BUILD === 'undefined') {
        profile.BUILD = ''
      }
      if (typeof profile.APARTMENT === 'undefined') {
        profile.APARTMENT = ''
      }

      if (profile.LAST_CHOICES) delete profile.LAST_CHOICES

      let city = this.positionData.CITY_NAME
      if (this.positionData.CITY_NAME === 'Москва') {
        city = this.$courierMskZone(this.lastGooglePosition) || 'Москва'
      }

      // Адрес в Москве попал в зону за МКАД — /order ниже считает доставку по
      // этой зоне (city), а блок «Варианты доставки» остаётся с ценами по городу
      // «Москва». Перезапрашиваем /delivery по той же зоне, чтобы цены совпадали.
      // Только курьер и только при смене зоны (внутри syncMskZoneDelivery).
      if (this.activeDeliveryType?.ID === 'COURIER') {
        this.syncMskZoneDelivery(city)
      }

      if (this.positionData.CITY_NAME !== city) {
        if (document.getElementById('I_COURIER_1DAY'))
          document.getElementById(
            'I_COURIER_1DAY'
          ).parentElement.style.display = 'none'
      } else {
        if (document.getElementById('I_COURIER_1DAY'))
          document.getElementById(
            'I_COURIER_1DAY'
          ).parentElement.style.display = 'flex'
      }

      profile.AREA = this.positionData.AREA_NAM
      profile.CITY = city
      profile.COUNTRY = this.positionData.COUNTRY_CODE
      profile.COUNTRY_NAME = this.positionData.COUNTRY_NAME
      profile.DELIVERY_TYPE = this.activeDeliveryType?.ID

      profile.EMAIL = ''
      profile.FIO = ''
      profile.PHONE = ''

      if (
        this.selectedPickpointInfo !== null &&
        this.selectedPickpointInfo !== undefined
      ) {
        profile.STREET = this.selectedPickpointInfo.ADDRESS
        profile.BUILD = ''
        profile.APARTMENT = ''
        profile.POSTINDEX = ''

        // запомнить: город и область из пикпоинтов ломают заказ
        // if (this.selectedPickpointInfo.CITY) {
        //   profile.CITY = this.selectedPickpointInfo.CITY
        // }
        // if (this.selectedPickpointInfo.REGION) {
        //   profile.AREA = this.selectedPickpointInfo.REGION
        // }

        profile.PICK_POINT_CODE = this.selectedPickpointInfo.CODE
        profile.PICK_POINT_SERVICE = this.selectedPickpointInfo.TYPE

        if (this.getCountryCode === 'PL') {
          profile.ADDRESS = this.selectedPickpointInfo.ADDRESS
          const addPart = this.selectedPickpointInfo.ADDRESS.split(' ')
          profile.POSTINDEX = addPart[0] //.replace('-', '');
          profile.BUILD_APART_NUM = addPart[addPart.length - 1]
        }
      }

      try {
        let deliveryId = this.selectedDeliveryService
        if (
          this.activeDeliveryType?.ID === 'PICK_POINT' &&
          this.selectedPickpointInfo
        ) {
          deliveryId = this.selectedPickpointInfo.TYPE
        }
        const positionData = {
          ...this.positionData,
        }
        positionData.CITY_NAME = city
        await this.$store.dispatch('GET_ORDER_DATA', {
          deliveryId: deliveryId,
          paymentId: this.activePaymentType,
          positionData: positionData,
          profile: profile,
          pickPoint:
            this.activeDeliveryType?.ID === 'PICK_POINT'
              ? this.selectedPickpointInfo?.CODE
              : false,
        })

        if (
          this.positionData.CITY_NAME !== city &&
          this.positionData.CITY_NAME === 'Москва'
        ) {
          if (document.querySelector("label[for='I_M_RUNNER']")) {
            const el = document.querySelector("label[for='I_M_RUNNER']")
            el.innerHTML =
              el.dataset.label +
              ' ' +
              this.formatMoney(this.$store.state.orderData.DELIVERY_PRICE)
          }
        } else {
          if (document.querySelector("label[for='I_M_RUNNER']")) {
            const el = document.querySelector("label[for='I_M_RUNNER']")
            el.innerHTML = el.dataset.label + ' ' + el.dataset.price
          }
        }
      } catch (err) {
        this.errors.api.push(err)
      }
    },
    checkActive(id) {
      return document.activeElement.getAttribute('id') === id
    },
    openAuth() {
      this.authopen = true
      if (document.querySelector('.basket-summary-wrap'))
        document.querySelector('.basket-summary-wrap').style.zIndex = 5000
    },
    onClose() {
      this.authopen = false
      setTimeout(() => {
        if (document.querySelector('.basket-summary-wrap'))
          document
            .querySelector('.basket-summary-wrap')
            .removeAttribute('style')
      }, 460)
    },

    backToCart() {
      document.location.href = '/basket/'
    },
    lockNewProfileBtn() {
      this.isProcessing = true
      setTimeout(() => {
        this.isProcessing = false
      }, 5000)
    },

    /**
     * Применяет данные выбранного профиля после подтверждения смены города.
     * Вызывается из handleContinueWithUnavailable (localityCheckMixin)
     * когда triggerSource === 'profileChange'.
     */
    _applyPendingProfileData() {
      const profile = this.$store.state.SELECTED_PROFILE
      if (!profile) return
      const addressFio = profile.ADDRESS_INFO_FIELDS

      this.userInfo = {
        FIO: addressFio.FIO,
        PHONE: addressFio.PHONE,
        EMAIL: addressFio.EMAIL,
      }

      this.positionData.AREA_NAME = addressFio.AREA
      this.positionData.CITY_NAME = addressFio.CITY
      this.positionData.COUNTRY_NAME = addressFio.COUNTRY

      this.addressInfo.PROFILE = { ...addressFio }
      this.addressInfo.formatted = formatAddress(addressFio)

      this.applyProfileDelivery(profile)
      this.$store.commit('toggleServiceState', !this.serviceState)
    },

    /**
     * 💾 Обновляет данные профиля перед сохранением заказа
     * @returns {Promise<boolean>} - true если обновление прошло успешно
     */
    async updateProfileBeforeOrder() {
      try {
        let courierCity = this.positionData.CITY_NAME
        if (this.positionData.CITY_NAME === 'Москва') {
          courierCity =
            this.$courierMskZone(this.lastGooglePosition) || 'Москва'
        }

        const context = {
          orderData: this.orderData,
          additionalInfo: this.additionalInfo,
          positionData: this.positionData,
          activeDeliveryType: this.activeDeliveryType,
          selectedDeliveryService: this.selectedDeliveryService,
          selectedPickpointInfo: this.selectedPickpointInfo,
          activePaymentType: this.activePaymentType,
          selectedProfileId: this.selectedProfileId,
          profileAddressComment: this.profileAddressComment,
          getCountryCode: this.getCountryCode,
          isHiddenCommentBlock: this.isHiddenCommentBlock,
          courierCity,
        }

        const payload = buildProfileUpdatePayload(context)
        // Валидируем данные
        const validation = validateProfilePayload(payload)
        if (!validation.isValid) {
          console.error('❌ Ошибки валидации профиля:', validation.errors)
        }

        // Отправляем обновление профиля
        await this.$store.dispatch('UPDATE_DELIVERY_PROFILE', payload)

        return true
      } catch (error) {
        console.error('❌ Критическая ошибка при обновлении профиля:', error)
        return false
      }
    },

    async saveOrder() {
      this.loading.save = true

      if (this.getCountryCode === 'PL') {
        this.additionalInfo.PROFILE.IS_COMPANY = this.isCompany
        if (this.isCompany) {
          this.additionalInfo.PROFILE.FAKTURA_FIO = null
        } else {
          this.additionalInfo.PROFILE.FAKTURA_COMPANY = null
          this.additionalInfo.PROFILE.FAKTURA_INN = null
        }
      }

      if (this.isUpdatingProfile) {
        const updateSuccess = await this.updateProfileBeforeOrder()

        if (!updateSuccess) {
          console.error('❌ Не удалось обновить профиль')
        }
      }

      let deliveryId = this.selectedDeliveryService
      if (this.activeDeliveryType?.ID === 'PICK_POINT') {
        deliveryId = this.selectedPickpointInfo.TYPE
      }
      const orderData = {
        // receiverId: this.selectedData.receiver.ID,
        deliveryId: deliveryId,
        ...(this.isUpdatingProfile
          ? { profileId: this.selectedProfileId }
          : {}),
        paymentId: this.activePaymentType, // ид оплаты да
        EMAIL: this.orderData.EMAIL, //	емейл	да
        FIO: this.orderData.FIO, //	ФИО	да
        PHONE: this.orderData.PHONE.replace(/[^0-9+]/g, ''), //	телефон	да
        PROFILE: {
          ...this.orderData.PROFILE,
          ...this.additionalInfo.PROFILE,
        },
        additionalOrderInfo: this.$store.state.additionalOrderInfo, // массив с дополнительными данными заказа, элементы массива смотри ниже	да
        memberId: this.$store.state.memberId, //	ид рекомендателя	только в неавториз
        dutyEnabled: this.dutyEnabled,
      }

      if (window.addressManual) {
        orderData.PROFILE.MANUAL = 1
      }

      if (this.authed) {
        orderData.bonusUse = !this.isUseCoralWallet // использовать ли оплату бонусами	только в авториз
        orderData.bonusUseValue = this.wallet.use
        orderData.promo = this.promo
      }

      if (typeof orderData.PROFILE.BUILD === 'undefined') {
        orderData.PROFILE.BUILD = ''
      }
      if (typeof orderData.PROFILE.APARTMENT === 'undefined') {
        orderData.PROFILE.APARTMENT = ''
      }

      if (orderData.PROFILE.LAST_CHOICES) delete orderData.PROFILE.LAST_CHOICES

      if (
        typeof this.profileAddressComment === 'string' &&
        this.profileAddressComment !== ''
      ) {
        orderData.PROFILE.COMMENT = this.profileAddressComment
        if (typeof orderData.additionalOrderInfo.orderComment !== 'string')
          orderData.additionalOrderInfo.orderComment = ''
        orderData.additionalOrderInfo.orderComment +=
          '\n' + this.profileAddressComment
      }

      if (
        this.$store.state.promo !== '' &&
        this.$store.state.promoDiscount.DISCOUNT > 0
      ) {
        orderData.promo = this.$store.state.promo
      }

      orderData.PROFILE.AREA = this.positionData.AREA_NAME

      let city = this.positionData.CITY_NAME
      if (this.positionData.CITY_NAME === 'Москва') {
        city = this.$courierMskZone(this.lastGooglePosition) || 'Москва'
      }
      orderData.PROFILE.CITY = city

      if (
        (!orderData.PROFILE.AREA ||
          orderData.PROFILE.AREA === orderData.PROFILE.CITY) &&
        this.isCrimea(orderData.PROFILE.CITY)
      ) {
        orderData.PROFILE.AREA = 'Крым Республика'
      }

      if (!orderData.PROFILE.AREA)
        orderData.PROFILE.AREA = orderData.PROFILE.CITY

      orderData.PROFILE.COUNTRY = this.getCountryCode
      orderData.PROFILE.COUNTRY_NAME = this.$store.state.country.name
      orderData.PROFILE.DELIVERY_TYPE = this.activeDeliveryType?.ID

      orderData.PROFILE.EMAIL = this.orderData.EMAIL
      orderData.PROFILE.FIO = this.orderData.FIO
      orderData.PROFILE.PHONE = this.orderData.PHONE.replace(/[^0-9+]/g, '')

      if (this.deliveryTime !== false) {
        orderData.DELIVERY_DATE = this.deliveryTime.DELIVERY_DATE
        orderData.DELIVERY_FROM = this.deliveryTime.DELIVERY_FROM
        orderData.DELIVERY_TO = this.deliveryTime.DELIVERY_TO
      }

      if (
        this.selectedPickpointInfo !== null &&
        this.selectedPickpointInfo !== undefined
      ) {
        orderData.PROFILE.STREET = this.selectedPickpointInfo.ADDRESS
        orderData.PROFILE.BUILD = ''
        orderData.PROFILE.APARTMENT = ''
        orderData.PROFILE.POSTINDEX = ''

        // запомнить: город и область из пикпоинтов ломают заказ
        // if (this.selectedPickpointInfo.CITY) {
        //   orderData.PROFILE.CITY = this.selectedPickpointInfo.CITY
        // }
        // if (this.selectedPickpointInfo.REGION) {
        //   orderData.PROFILE.AREA = this.selectedPickpointInfo.REGION
        // }

        orderData.pickPoint = this.selectedPickpointInfo.CODE
        orderData.PROFILE.PICK_POINT_CODE = this.selectedPickpointInfo.CODE
        orderData.PROFILE.PICK_POINT_SERVICE = this.selectedPickpointInfo.TYPE
        orderData.deliveryId = this.selectedPickpointInfo.TYPE

        if (this.getCountryCode === 'PL') {
          orderData.PROFILE.ADDRESS = this.selectedPickpointInfo.ADDRESS
          const addPart = this.selectedPickpointInfo.ADDRESS.split(' ')
          orderData.PROFILE.POSTINDEX = addPart[0] //.replace('-', '');
          orderData.PROFILE.BUILD_APART_NUM = addPart[addPart.length - 1]
        }
      }

      if (this.getCountryCode === 'PL' || this.getCountryCode === 'PT') {
        orderData.PROFILE.POSTINDEX = this.orderData.PROFILE.POSTINDEX?.replace(
          /[^0-9]/g,
          ''
        )
      }

      try {
        const response = await this.$store.dispatch('CREATE_ORDER', orderData)
        if (response.data.result) {
          const orderId = response.data.result
          window.setCookie('orderResultId', orderId, 8)
          try {
            if (
              document.location.hostname === 'localhost' &&
              window.uid &&
              window.uid === '2804051' &&
              this.getCountry.code === 'US'
            ) {
              history.replaceState(
                {},
                '',
                '/personal-new/shop/orders/' + orderId
              )
            }
          } catch (err) {
            console.log(err)
          }

          trackPurchase({
            event: 'purchase',
            payment_method: this.activePaymentTypeName || null,
            ecommerce: {
              transaction_id: response.data.result, // ID заказа
              value: this.$store.state.orderData.FULL_PRICE,
              shipping: this.$store.state.orderData.DELIVERY_PRICE, // Стоимость доставки, учитывая купон
              tax: this.$store.state.orderData.TAX, // Взимаемые налоги
              currency: this.$store.state.currency, // Валюта товара
              bonus_points: this.$store.state.orderData.STANDARD_POINTS ?? 0,
              items: toGaItems(this.$store.state.basketItems),
            },
          })

          captureCheckoutEvent({
            eventId: 'checkout.purchase',
            level: 'info',
            context: getCheckoutContext(this.$store),
            extraFields: {
              domain: window.location.hostname,
            },
          })

          const paymentPath =
            this.getCountryCode === 'RU' || this.getCountryCode === 'BY'
              ? `/order/payment/${orderId}/?new_checkout=1`
              : `/order/payment/${orderId}/${this.activePaymentType}/?new_checkout=1`
          document.location.href = paymentPath
        } else {
          this.setApiErrors([response.data.error])
          this.loading.save = false

          // Отправляем событие об ошибке оформления: бэкенд вернул ошибку
          // в теле HTTP 200, без этого события она не попала бы в Sentry.
          captureOrderValidationFailed({
            context: getCheckoutContext(this.$store),
            provider:
              this.activePaymentType?.toString() || 'checkoutSentry.unknown',
            failureReason: response.data.error,
            errorCode: response.data.errorTitle,
          })
        }
      } catch (err) {
        this.loading.save = false
        console.log(JSON.stringify(err.response))
        this.addApiError(
          this.$t('error') + ': ' + (err.response ? err.response?.status : err)
        )
        if (err.response?.data?.error)
          this.setApiErrors(this.apiErrors.concat(err.response.data.error))

        // Отправляем событие о технической ошибке при создании заказа:
        // interceptor api.js заворачивает HTTP-ошибки (422 ORDER_ZIP,
        // PROFILE_CREATION_ERROR, ...) в ApiError, extractApiError
        // достаёт из него текст и errorTitle для тегов Sentry.
        const { error, errorTitle } = extractApiError(err)

        if (!error) return

        capturePaymentTransactionFailed({
          context: getCheckoutContext(this.$store),
          provider:
            this.activePaymentType?.toString() || 'checkoutSentry.unknown',
          failureReason: error,
          errorCode: errorTitle,
        })
      }
    },
    async getFieldsConfig() {
      this.fieldsConfig = this.$store.state.checkoutFields
      const USER_INFO_FIELDS = [
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_fio'),
          name: 'FIO',
          required: true,
          type: 'text',
        },
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_phone'),
          name: 'PHONE',
          required: true,
          type: 'tel',
        },
        {
          group: 'USER_INFO_FIELDS',
          label: this.$t('reciever_email'),
          name: 'EMAIL',
          required: true,
          type: 'email',
        },
      ]
      this.fieldsConfig.USER_INFO_FIELDS = USER_INFO_FIELDS
      if (!this.fieldsConfig) {
        throw new Error(this.$t('fields_config_error'))
      }
    },

    /**
     * ⚙️ Определяет, какой способ доставки должен быть выбран при инициализации.
     * Не мутирует состояние компонента, только возвращает решение.
     * @returns {{dt: object, service: Object} | null} - Объект с данными для установки или null.
     */
    _determineInitialDelivery() {
      const { deliveryTypes, isSelectedProfile } = this
      const profile = this.$store.state.SELECTED_PROFILE

      // Сохранённый в профиле сервис отсутствует в ответе /delivery —
      // подбираем запасной вариант по приоритету (COURIER > PICK_POINT > POST).
      // Ранний выход обязателен: даже если резолв ничего не вернул, нельзя
      // отдавать сценарию 1 битый SERVICE.ID — пользователь увидел бы
      // сохранённый сервис, которого нет среди доступных.
      if (isSelectedProfile && this.deliveryUnavailable) {
        const resolved = resolveAvailableDelivery(profile, deliveryTypes)
        if (resolved) {
          return { dt: resolved.deliveryType, service: resolved.service }
        }
        return null
      }

      const selectedDeliveryService =
        profile?.LAST_CHOICES?.LAST_DELIVERY_TYPE?.SERVICE?.ID

      // --- Сценарий 1: У пользователя выбран профиль ---
      if (isSelectedProfile) {
        for (const dt of deliveryTypes) {
          // Ищем не просто наличие, а сам объект сервиса
          const foundService = dt.ITEMS.find(
            (item) => item.ID === selectedDeliveryService
          )
          if (foundService) {
            return { dt, service: foundService }
          }
        }
      }
      // Если цикл завершился, а доставка не найдена - выводим предупреждение и переходим к fallback. Но! надо поменять: сейчас данные отправляются в сентри даже когда люди очищают все поля.
      // Sentry.captureMessage(
      //   `Предпочитаемый способ доставки "${selectedDeliveryService}" из профиля не найден среди доступных. Выбираем первый по умолчанию.`
      // )

      // --- Сценарий 2 (Fallback): если доставка из профиля недоступна ---
      if (deliveryTypes.length > 0 && deliveryTypes[0].ITEMS?.length > 0) {
        const fallbackDt = deliveryTypes[0]
        const fallbackService = fallbackDt.ITEMS[0]
        return { dt: fallbackDt, service: fallbackService }
      }

      // --- Сценарий 3: API не вернул ни одного способа доставки ---
      return null
    },

    /**
     * 🚀 Устанавливает активный способ доставки и запускает загрузку способов оплаты.
     * Мутирует состояние компонента.
     */
    async _setupActiveDelivery() {
      const deliveryData = this._determineInitialDelivery()

      if (!deliveryData) return

      this.activeDeliveryType = deliveryData.dt

      if (deliveryData.service) {
        this.$store.commit(
          'UpdateSelectedDeliveryTypeService',
          deliveryData.service.ID
        )
        // фоллбек на случай если selectedProfileId-watcher отработал до
        // загрузки deliveryTypes и activeDeliveryType.ID был пустой
        if (this.isSelectedProfile) {
          this.reportDeliveryPrefill(deliveryData.dt?.ID)
        }
        await this.getPaymentTypesByService(deliveryData.service)
        // Валидный ПВЗ-профиль: список ПВЗ подгружаем и здесь. Иначе при
        // выборе профиля-самовывоза (или смене города) список остаётся
        // пустым/от прошлого города до ручного переключения курьерка↔ПВЗ.
        if (deliveryData.dt.ID === 'PICK_POINT') {
          await this.getPickpoints()
        }
      } else {
        // Сервис должен выбрать пользователь (битый ПВЗ / резервный тип после битой курьерки)
        this.$store.commit('UpdateSelectedDeliveryTypeService', undefined)
        this.$store.commit('UpdateSelectedPickpointInfo', undefined)
        this.selectedPickpointInfo = undefined
        this.paymentTypes = []
        // Для PICK_POINT нужно подгрузить список ПВЗ и снять скелетон —
        // showSearchTools переключается в true только внутри getPickpoints.
        if (deliveryData.dt.ID === 'PICK_POINT') {
          await this.getPickpoints()
        }
      }
    },

    /**
     * Устанавливает тип/сервис доставки из выбранного профиля.
     * Если сохранённый сервис отсутствует в ответе /delivery — применяет
     * правила запасного варианта (приоритет COURIER > PICK_POINT > POST).
     */
    applyProfileDelivery(profile) {
      // Сервис из LAST_CHOICES не найден в deliveryTypes: пытаемся применить
      // fallback. Если deliveryTypes ещё пустой (resolved === null), молча
      // выходим — НЕ перетираем state битым сервисом. Когда /delivery придёт,
      // сработает watcher deliveryTypes и переприменит fallback.
      if (this.deliveryUnavailable) {
        const resolved = resolveAvailableDelivery(profile, this.deliveryTypes)
        if (!resolved) return
        this.activeDeliveryType = resolved.deliveryType
        this.$store.commit(
          'UpdateSelectedDeliveryTypeService',
          resolved.service?.ID
        )
        this.$store.commit('UpdateSelectedPickpointInfo', undefined)
        this.selectedPickpointInfo = undefined
        // PICK_POINT: showSearchTools переключается в true только внутри
        // getPickpoints — без вызова DeliveryTypes.vue показывает скелетон.
        if (resolved.deliveryType.ID === 'PICK_POINT') {
          this.getPickpoints()
        }
        return
      }

      // Профиль валидный — обычная установка из LAST_CHOICES.
      this.activeDeliveryType =
        profile.LAST_CHOICES?.LAST_DELIVERY_TYPE ||
        this.deliveryTypes.find(
          (el) => el.ID === profile.ADDRESS_INFO_FIELDS.DELIVERY_TYPE
        ) ||
        {}
      this.$store.commit(
        'UpdateSelectedDeliveryTypeService',
        profile.LAST_CHOICES?.LAST_DELIVERY_TYPE?.SERVICE?.ID ||
          this.activeDeliveryType?.ITEMS?.[0]?.ID
      )
    },

    /**
     * Теперь в getDeliveryTypes
     * - сначала подставляем из профиля (checkLastProfile)
     * - диспатчим GET_DELIVERY_TYPES
     * - если lastServiceId есть, пытаемся найти среди типов доставки
     *   тот, в который пользователь ходил в прошлый раз
     * - иначе — обычный fallback на первый deliveryType
     */
    async getDeliveryTypes() {
      // Для RU: защита от двойного вызова при резолве localityCheckPromise
      if (this.getCountryCode === 'RU' && this._deliveryTypesInProgress) return
      if (this.getCountryCode === 'RU') this._deliveryTypesInProgress = true

      this.loading.deliveryTypes = true
      this.loading.map = true
      perfStart('checkout:delivery-types')

      try {
        // Для RU дожидаемся завершения проверки наличия (checkLocality),
        // чтобы запрос /delivery шёл после получения ответа checkLocality
        if (this.localityCheckPromise) {
          await this.localityCheckPromise
          this.localityCheckPromise = null
        }
        // запросим доступные способы доставки по positionData.
        // Промис сохраняем, чтобы getPickpoints мог дождаться свежего /delivery
        const deliveryPromise = this.$store.dispatch(
          'GET_DELIVERY_TYPES',
          this.positionData
        )
        this._deliveryPromise = deliveryPromise
        try {
          await deliveryPromise
        } finally {
          // обнуляем только свой промис — чтобы не затереть более свежий
          if (this._deliveryPromise === deliveryPromise) {
            this._deliveryPromise = null
          }
        }
        this.setIsDeliveryLoadingWhenProfileSelected(false)
        this.deliveryTypes = this.$store.state.deliveryTypes
        // зона, по которой реально загружен /delivery — чтобы syncMskZoneDelivery
        // не делал лишний перезапрос для адреса в той же зоне
        this._lastDeliveryZone = this.positionData.CITY_NAME

        // если был lastServiceId — найдём deliveryType и paymentItem под него. Запускаем логику выбора и установки начального способа доставки
        await this._setupActiveDelivery()
      } catch (error) {
        console.error(error)
        this.addApiError(this.$store.state.deliveryError)
        this.$nextTick(() => {
          this.loading.main = true
        })
      } finally {
        this._deliveryTypesInProgress = false
        this.loading.deliveryTypes = false
        this.loading.map = false
        perfEnd('checkout:delivery-types')
        this.stopLoadingMain()
      }
    },

    /**
     * Синхронизирует стоимость доставки в блоке «Варианты доставки» при выборе
     * адреса в Москве. Поле «Город доставки» остаётся «Москва», поэтому /delivery
     * сам не перезапрашивается. Но при адресе за МКАД ($courierMskZone возвращает
     * «Москва (за МКАД)» / «Москва 2») /order считает доставку по другой зоне, и
     * в basketHolder приходит другая стоимость, чем показана в блоке доставки
     * (загруженном по городу «Москва»). Перезапрашиваем /delivery по зоне курьера,
     * чтобы цены совпадали в обоих местах. Вызывается из updateBasket с уже
     * посчитанной зоной; запрос идёт только при её смене.
     * @param {string} zoneCity — город зоны курьера (например «Москва (за МКАД)»)
     */
    async syncMskZoneDelivery(zoneCity) {
      if (!zoneCity) return
      if (this._lastDeliveryZone === zoneCity) return
      this._lastDeliveryZone = zoneCity

      const positionData = { ...this.positionData, CITY_NAME: zoneCity }
      try {
        this.loading.deliveryTypes = true
        await this.$store.dispatch('GET_DELIVERY_TYPES', positionData)
        this.deliveryTypes = this.$store.state.deliveryTypes
        // activeDeliveryType ссылается на объект из прошлого ответа /delivery —
        // переустанавливаем на актуальный, сохранив выбранный сервис.
        if (this.activeDeliveryType?.ID) {
          const match = this.deliveryTypes.find(
            (dt) => dt.ID === this.activeDeliveryType.ID
          )
          if (match) this.activeDeliveryType = match
        }
      } catch (error) {
        console.error(error)
        this.errors.api.push(this.$store.state.deliveryError)
      } finally {
        this.loading.deliveryTypes = false
      }
    },

    async getPickpoints() {
      // Дожидаемся текущего /delivery: реактивный вызов из useActiveDeliveryType
      if (this._deliveryPromise) {
        try {
          await this._deliveryPromise
        } catch {
          // продолжаем
        }
      }
      const cityName = this.positionData.CITY_NAME
      const cached = this.$store.state.pickpoints[cityName]
      if (
        getPickpointAttempts(cityName) < MAX_PICKPOINT_ATTEMPTS &&
        (!cached || cached.length === 0)
      ) {
        incrementPickpointAttempts(cityName)
        try {
          this.loading.pickpoints = true
          await this.$store.dispatch('GET_PICKPOINTS', this.positionData)
          if (this.$store.state.pickpoints[cityName]?.length > 0) {
            resetPickpointAttempts(cityName)
          }
          this.$nextTick(() => {
            this.typesFilterTrigger++
          })
          /* this.pickpoints = this.$store.getters.getPickpointsList(
            this.positionData.CITY_NAME
          ); */
        } catch (error) {
          console.log(error)
        }
        this.loading.pickpoints = false
      }
      this.filteredPickpoints = [] // this.pickpoints;
      this.loading.map = false
      this.showSearchTools = true

      this.selectPpAfterChangeCity()
    },
    selectPpAfterChangeCity() {
      // Сервис из LAST_CHOICES отсутствует в /delivery — сохранённый ПВЗ
      // считается битым, авто-восстанавливать его нельзя (иначе перетрёт
      // сброс из applyProfileDelivery).
      if (this.deliveryUnavailable) return
      if (!this.getAllPickpoints?.length || !this.lastPickpointCode) return

      const pp = this.getAllPickpoints.find(
        (p) => p.CODE === this.lastPickpointCode
      )
      if (pp) {
        this.selectPickpoint(pp) // будто кликнули «Выбрать»
      }
    },

    /**
     * ⚙️ Получает способы оплаты: сначала из объекта сервиса,
     * а если их там нет - запрашивает через API (fallback).
     * @param {object} service - Объект сервиса доставки (например, { ID: 'I_SDEK_P', PAYSYSTEMS: [...] })
     * @returns {Promise<Array>} - Промис, который разрешается массивом способов оплаты.
     */
    async _fetchOrGetPaymentSystems(service) {
      // PAYSYSTEMS для курьерок, paymentSystems для самовывоза
      const PAYSYSTEMS = service.PAYSYSTEMS || service.paymentSystems
      // ID для курьерок, TYPE для самовывоза
      const serviceId = service.ID || service.TYPE
      // --- Данные уже есть в ответе /delivery ---
      if (Array.isArray(PAYSYSTEMS) && PAYSYSTEMS.length > 0) {
        this.$store.commit('UpdatePaymentTypesList', {
          payload: PAYSYSTEMS,
          deliveryServiceId: serviceId,
        })
        // Просто возвращаем уже имеющиеся данные
        return Promise.resolve(PAYSYSTEMS)
      }

      // Проверяем кэш в Vuex
      const pt = this.$store.getters.getPaymentTypes(serviceId)
      if (pt) {
        return Promise.resolve(pt)
      }

      // Если в кэше нет - делаем запрос
      try {
        await this.$store.dispatch('GET_PAYMENT_TYPES', {
          deliveryServiceId: serviceId,
          positionData: this.positionData,
        })
        return this.$store.getters.getPaymentTypes(serviceId) || []
      } catch (error) {
        console.error(
          `Ошибка при запросе способов оплаты для "${serviceId}":`,
          error
        )
        return Promise.resolve([]) // Возвращаем пустой массив в случае ошибки
      }
    },

    /**
     * Определяет, какой способ оплаты сделать активным.
     * @param {Array} paymentTypes - Массив доступных способов оплаты.
     * @returns {object} - Активный способ оплаты.
     */
    _determineActivePaymentMethod(paymentTypes) {
      // По умолчанию - первый в списке
      let activePayment = paymentTypes[0]

      if (this.isSelectedProfile) {
        const lastPaymentId =
          this.$store.state.SELECTED_PROFILE?.LAST_CHOICES?.LAST_PAYMENT_TYPE
            ?.ID
        if (lastPaymentId) {
          const found = paymentTypes.find((p) => p.ID === lastPaymentId)
          if (found) {
            activePayment = found // Если нашли в профиле - он становится активным
          }
        }
        return activePayment
      }

      if (this.activePaymentType) {
        const current = paymentTypes.find(
          (p) => p.ID === this.activePaymentType
        )
        if (current) {
          activePayment = current
        }
      }
      return activePayment
    },
    /**
     * Отдает объект сервиса взамен на его ID.
     * @param {String} id - ID сервиса.
     * @returns {object} - Объект сервиса.
     */
    _findServiceById(id) {
      const allDeliveryServices = this.deliveryTypes.flatMap(
        (deliveryType) => deliveryType.ITEMS
      )

      // ищем в этом плоском массиве сервис по ID
      const service = allDeliveryServices.find((item) => item.ID === id)
      return service
    },

    async getPaymentTypesByService(service) {
      if (!service) return

      // Если service пришел как строка (ID), ищем соответствующий объект
      if (typeof service === 'string') service = this._findServiceById(service)
      if (!service) return

      this.loading.paymentTypes = true
      this.$store.commit('UpdateSelectedDeliveryTypeService', service.ID)

      try {
        // 1. Получаем способы оплаты
        const paymentSystems = await this._fetchOrGetPaymentSystems(service)
        this.paymentTypes = paymentSystems

        // 2. Выбираем и устанавливаем активный способ оплаты
        if (this.paymentTypes.length > 0) {
          const activePayment = this._determineActivePaymentMethod(
            this.paymentTypes
          )
          this.setActivePaymentMethod(activePayment?.ID, activePayment.NAME)
        } else {
          // Если способов оплаты нет, очищаем активный
          this.activePaymentType = undefined

          // 3. Обновляем корзину с учетом новой информации
          await this.updateBasket()
        }
      } catch (error) {
        console.error(
          `Критическая ошибка в getPaymentTypesByService для "${service.ID}":`,
          error
        )
      } finally {
        this.loading.paymentTypes = false
      }
    },
    async setActiveDeliveryType(delivery) {
      this.cancelAddressPending()
      this.filteredPickpoints = []
      this.filteredTypesPickpoints = []

      const lastDeliveryType = JSON.parse(
        JSON.stringify(this.activeDeliveryType)
      )
      this.activeDeliveryType = delivery

      if (this.activeDeliveryType?.ID === 'PICK_POINT') {
        await this.getPickpoints()
        if (
          this.$store.state.pickpoints[this.positionData.CITY_NAME] &&
          this.$store.state.pickpoints[this.positionData.CITY_NAME] != []
        ) {
          this.loading.map = true
          this.loading.map = false
        } else {
          this.activeDeliveryType = lastDeliveryType
          // alert(this.$t('cant_change_to_pickpoint'));
        }
      }
      if (
        this.activeDeliveryType?.ID == 'COURIER' &&
        this.courierAddressMarker.lat &&
        this.courierAddressMarker.lng
      ) {
        this.setMapCordsForZoom(this.courierAddressMarker)
      }

      if (this.activeDeliveryType?.ID == 'PICKUP_EVENT') {
        this.addressInfo.PROFILE.ADDRESS = 'Galicyjska'
        this.addressInfo.PROFILE.STREET = 'Galicyjska'
        this.addressInfo.PROFILE.BUILD = '9'
        this.addressInfo.PROFILE.BUILD_APART_NUM = '9'
        this.addressInfo.PROFILE.POSTINDEX = '0000000'
      }

      if (this.activeDeliveryType?.ID !== 'PICK_POINT') {
        this.selectPickpoint(undefined)
        if (!this.isSelectedProfile) {
          this.resetAddressToStepCity()
        }
      }

      await this.updateBasket()
      this.setHiddenFields(false)
    },
    async setActivePaymentMethod(id, name) {
      if (id) {
        this.loading.paymentTypes = true
        try {
          await this.$store.commit('UpdateActivePaymentType', id)
          this.activePaymentType = this.$store.state.activePaymentType
          await this.updateBasket()
          if (name !== undefined) {
            this.activePaymentTypeName = name
          }
          this.loading.paymentTypes = false
        } catch (error) {
          console.log(error)
          this.loading.paymentTypes = false
        }
      } else {
        this.activePaymentType = undefined
      }
    },
    showPickpointInfo(pickpointData) {
      if (pickpointData && Object.keys(pickpointData).length) {
        // this.showPickpointInfoModal = true
        this.activePickpoint = JSON.parse(JSON.stringify(pickpointData))
        this.zoomToCordsObj = {
          lat: pickpointData.position.lat,
          lng: pickpointData.position.lng,
        }

        // TODO Бек говорит, что не учитывает никакой префикс. Удалим после того как убедимся, что все верно, и код не нужен

        // let companyInfo = false
        // let inMkad = true
        //
        // if (pickpointData.REGION === 'Москва') {
        //   inMkad = this.$isObjectInPolygonMsk(pickpointData.position)
        // } else if (pickpointData.REGION === 'Київ') {
        //   inMkad = this.$isObjectInPolygonKiev(pickpointData.position)
        // } else if (pickpointData.REGION === 'Санкт-Петербург') {
        //   inMkad = this.$isObjectInPolygonSpb(pickpointData.position)
        // }
        //
        // if (!inMkad) {
        //   companyInfo = this.getDeliveryCompanyInfo(
        //     pickpointData.TYPE + '_ZAMKAD'
        //   )
        //   this.activePickpoint.TYPE += '_ZAMKAD'
        // }

        const companyInfo = this.getDeliveryCompanyInfo(pickpointData.TYPE)

        this.activePickpoint.deliveryCompanyName = companyInfo.name
        this.activePickpoint.deliveryCompanyIcon = companyInfo.icon
        this.activePickpoint.paymentSystems = companyInfo.paymentSystems
        this.activePickpoint.price = companyInfo.price
      }
    },
    filterPickpointsByField(filt) {
      /* this.pickpoints = this.$store.getters.getPickpointsList(
        this.positionData.CITY_NAME
      ); */
      this.filteredPickpoints = [] // this.pickpoints;
      if (filt.field.length > 0) {
        const normalizedSearch = normalizeString(filt.field).toLowerCase()

        this.filteredPickpoints = this.$store.state.pickpoints[
          this.positionData.CITY_NAME
        ].filter((value) => {
          const normalizedAddress = normalizeString(
            value.ADDRESS || ''
          ).toLowerCase()
          const normalizedName = normalizeString(value.NAME || '').toLowerCase()
          const normalizedEmail = normalizeString(
            value.EMAIL || ''
          ).toLowerCase()
          const normalizedCompanyName = normalizeString(
            this.getDeliveryCompanyInfo(value.TYPE).name || ''
          ).toLowerCase()

          return (
            normalizedAddress.includes(normalizedSearch) ||
            normalizedName.includes(normalizedSearch) ||
            normalizedEmail.includes(normalizedSearch) ||
            normalizedCompanyName.includes(normalizedSearch)
          )
        })
      }

      this.filteredTypesPickpoints = filt.types
      const types = []
      this.$store.state.pickpoints[this.positionData.CITY_NAME].forEach((v) => {
        if (!types.includes(v.TYPE)) types.push(v.TYPE)
      })

      if (filt.types.length > 0) {
        if (this.filteredPickpoints.length > 0) {
          if (filt.types !== types) {
            this.filteredPickpoints = this.filteredPickpoints.filter((value) =>
              filt.types.includes(value.TYPE)
            )
          }
        } else {
          if (filt.types !== types) {
            this.filteredPickpoints = this.$store.state.pickpoints[
              this.positionData.CITY_NAME
            ].filter((value) => filt.types.includes(value.TYPE))
          }
        }
      }
      this.searchPickpoints(this.searchTextPickpoints)
    },

    /*filterPickpointsByDeliveryType(types) {
      this.pickpoints = this.$store.getters.getPickpointsList(
        this.positionData.CITY_NAME
      );
      if (types.length === 0) {
        this.filteredPickpoints = []; // this.pickpoints;
      } else {
        // this.filteredPickpoints = [];
        if (this.filteredPickpoints.length === 0) {

        } else {

        }
        this.filteredPickpoints = this[this.filteredPickpoints === this.pickpoints ? 'pickpoints' : 'filteredPickpoints'].filter((value) =>
          types.includes(value.TYPE)
        );
      }
    },*/
    setMapCordsForZoom(cords) {
      // для корректной центровки карты, без setTimeout работает неверно
      setTimeout(() => {
        this.zoomToCordsObj = {
          lat: cords.lat,
          lng: cords.lng,
        }
      }, 0)
    },
    getFieldPropertyValue(group, field, property) {
      if (group && field && property && this.fieldsConfig[group]) {
        let foundField = this.fieldsConfig[group].find(
          (item) => item.name == field
        )
        if (foundField) {
          return foundField[property]
        }
      } else {
        return false
      }
    },
    /**
     * ВНИМАНИЕ: эта функция требует рефакторинга.
     *
     * Сейчас formPositionData делает слишком многое (нарушает SRP):
     *   1. Парсит address_components из Google-объекта
     *   2. Обновляет positionData (CITY_NAME, AREA_NAME, COUNTRY_*)
     *   3. Проверяет checkLocality для RU (с модалками и await)
     *   4. Вызывает getDeliveryTypes() и getPaymentTypesByService()
     *   5. Обновляет addressInfo.PROFILE
     *   6. Управляет UI (pickpoints, circle, zoomToCords, modalMainButtonDisabled)
     *   7. Обрабатывает смену города (cityToChange)
     *
     * План рефакторинга:
     *   1. Разделить на чистые функции: parseGooglePlace(googleObject) → positionData,
     *      applyCityPosition(positionData), fetchDeliveryAndPayment(positionData).
     *   2. Вынести RU-locality-flow в отдельный async-композитор (как localityCheckMixin,
     *      но с единым местом вызова, а не разбросанным по 3 методам).
     *   3. Перенести обновление addressInfo.PROFILE в watcher positionData,
     *      чтобы данные адреса следовали за городом автоматически.
     *   4. Убрать дублирование с watcher selectedProfileId, который уже
     *      устанавливает positionData из профиля — и formPositionData, и watcher
     *      делают одно и то же разными путями.
     *   5. Вынести UI-эффекты (circle, zoomToCords, модалки) в onMounted/watchers
     *      соответствующих компонентов, чтобы эта функция стала чистой логикой.
     */
    async formPositionData(googleObject, withProfile, source) {
      if (this.confirmCityChangeModal) return
      if (!withProfile && this.getCountryCode === 'PL') {
        this.setAdditionalFielads()
      }

      if (!googleObject || Object.keys(googleObject).length < 2) return
      this.$store.commit(
        'updateDefaultLocation',
        googleObject.geometry.location
      )
      const gCountry =
        googleObject.address_components.find((el) =>
          el.types.includes('country')
        )?.short_name ?? false

      if (this.userEditProfile) this.clearAddress()

      this.loading.setCity = true

      if (googleObject.name && googleObject.name.length) {
        this.googleObject = googleObject
      }
      // Изменение города по клике на модальное окно
      const changingCity = Object.keys(this.cityToChange).length
      if (changingCity) this.clearDataAfterCityChanges()

      if (googleObject && Object.keys(googleObject).length) {
        this.formattedAddress = googleObject.formatted_address
        const initialValues = googleObject.address_components
        if (initialValues && initialValues.length) {
          let hasAreaField = findArea(googleObject, this.getCountryCode)

          let hasCityField = findCity(googleObject, this.getCountryCode)

          if (
            (!hasAreaField ||
              hasAreaField?.long_name === hasCityField?.long_name) &&
            this.isCrimea(hasCityField?.long_name)
          ) {
            hasAreaField = {
              long_name: 'Крым Республика',
              short_name: 'Крым Республика',
            }
          }
          // Google на омонимах подменяет регион («Ивановка, Оренбургская область» → Приморский край). Если AREA ответа гугла разошлась с профильной —подменяем AREA на профильную и прогоняем данные дальше как обычно
          if (withProfile && hasAreaField?.long_name) {
            const profileArea =
              this.$store.state.SELECTED_PROFILE?.ADDRESS_INFO_FIELDS?.AREA
            if (profileArea?.trim()) {
              const norm = (s) => s.trim().toLowerCase()
              if (norm(profileArea) !== norm(hasAreaField.long_name)) {
                hasAreaField = {
                  long_name: profileArea,
                  short_name: profileArea,
                }
              }
            }
          }

          let hasCountryField = initialValues.find((element) =>
            element.types.includes('country')
          )
          // Для RU + cityField: проверяем checkLocality ДО обновления positionData,
          // чтобы order не ушёл с новым городом раньше подтверждения
          if (
            this.getCountryCode === 'RU' &&
            source === 'cityField' &&
            hasCityField &&
            hasCityField.long_name !== this.addressInfo.PROFILE.CITY
          ) {
            this.localityCheckPromise = new Promise((resolve) => {
              this.localityCheck._resolveLocalityCheck = resolve
            })

            const newArea = hasAreaField ? hasAreaField.long_name : ''
            const result = await this.checkLocalityFlow(
              hasCityField.long_name,
              newArea,
              'cityField'
            )
            if (result !== 'no_change') return
            this._resolveLocalityGate()
            this.localityCheckPromise = null
          }

          this.positionData.AREA_NAME = hasAreaField
            ? hasAreaField.long_name
            : null
          this.positionData.CITY_NAME = hasCityField
            ? hasCityField.long_name
            : null
          if (this.positionData.AREA_NAME === null) {
            this.positionData.AREA_NAME = this.positionData.CITY_NAME
          }
          this.positionData.COUNTRY_NAME = hasCountryField
            ? hasCountryField.long_name
            : null
          this.positionData.COUNTRY_CODE = hasCountryField
            ? hasCountryField.short_name
            : null

          if (this.isCrimea(hasCityField?.long_name)) {
            this.positionData.COUNTRY_CODE = 'RU'
            this.positionData.COUNTRY_NAME = 'Россия'
          }

          // Puerto Rico area patch
          if (gCountry === 'PR' && this.getCountry.code === 'US') {
            this.positionData.AREA_NAME = 'Puerto Rico'
          }

          // U.S. Virgin Islands area patch
          if (gCountry === 'VI' && this.getCountry.code === 'US') {
            this.positionData.AREA_NAME = 'U.S. Virgin Islands'
          }

          if (this.getCountry.code === 'IT') {
            this.positionData.AREA_NAME = hasAreaField.short_name
          }

          // защищаем мобилку от двух отправок события одновременно: город из профиля и сразу же город из хедера
          clearTimeout(this._cityChangedTimer)

          this._cityChangedTimer = setTimeout(() => {
            if (this.searchLocality.includes(this.getCountryCode)) {
              sendToNative('cityChanged', {
                place_id: googleObject.place_id || null,
                city_area: this.positionData.AREA_NAME || null,
                city_name: this.positionData.CITY_NAME || null,
              })
            }
          }, 2000)

          if (!this.checkIfObjectKeysAreEmpty(this.positionData)) {
            this.modalMainButtonDisabled = false
            if (this.pickpoints && this.pickpoints.length) {
              this.pickpoints = []
            }
            // TODO: ломает ПВЗ
            this.$store.commit('UpdateSelectedPickpointInfo', undefined)
            this.selectedPickpointInfo = this.$store.state.selectedPickpointInfo
            if (
              this.activePickpoint &&
              Object.keys(this.activePickpoint).length
            ) {
              this.activePickpoint = undefined
            }
            await this.getDeliveryTypes()
            await this.getPaymentTypesByService(
              this.$store.state.selectedDeliveryTypeService
            )

            const circle = new window.google.maps.Circle({
              center: {
                lat: googleObject.geometry.location.lat(),
                lng: googleObject.geometry.location.lng(),
              },
              radius: 24000,
            })
            this.positionData.circle = circle.getBounds()

            this.zoomToCordsObj = {
              lat: googleObject.geometry.location.lat(),
              lng: googleObject.geometry.location.lng(),
            }
            this.activePickpointsTemplate = 'list'
          }
          this.addressInfo.PROFILE.COUNTRY = this.getCountry.code
          this.addressInfo.PROFILE.COUNTRY_CODE = this.getCountry.code
          this.addressInfo.PROFILE.COUNTRY_NAME = this.getCountry.name

          if (this.positionData.AREA_NAME && this.positionData.AREA_NAME.length)
            this.addressInfo.PROFILE.AREA = this.positionData.AREA_NAME
          if (this.positionData.CITY_NAME && this.positionData.CITY_NAME.length)
            this.addressInfo.PROFILE.CITY = this.positionData.CITY_NAME
        }
      }
      if (changingCity) this.setDataAfterCityChanges(googleObject)

      this.loading.setCity = false
      this.choosePositionFromPositionModal()
    },
    clearAddress() {
      this.addressInfo = this.$options.data().addressInfo
    },

    // NOTE сбрасываем адрес доставки кроме указанных полей, чтобы не стирать выбранную страну и город
    // иными словами сбрасываем к шагу выбора города
    resetAddressToStepCity() {
      const keys = ['COUNTRY', 'COUNTRY_CODE', 'COUNTRY_NAME', 'AREA', 'CITY']
      this.addressInfo.PROFILE = Object.fromEntries(
        keys
          .filter((k) => k in this.addressInfo.PROFILE)
          .map((k) => [k, this.addressInfo.PROFILE[k]])
      )
    },
    clearCourierAddressMarker() {
      this.courierAddressMarker = this.$options.data().courierAddressMarker
    },
    clearDataAfterCityChanges() {
      this.clearAddress()
      this.clearCourierAddressMarker()
    },
    setDataAfterCityChanges(googleObject) {
      this.setMapCordsForZoom({
        lat: googleObject.geometry.location.lat(),
        lng: googleObject.geometry.location.lng(),
      })
      if (this.stepDeliveryAutocomplete) {
        this.stepDeliveryAutocomplete.$el.value =
          this.positionData.CITY_NAME + ', ' + this.positionData.COUNTRY_NAME
      }
    },
    checkPosition(event) {
      if (!event.trim().length) {
        this.formPositionData(this.googleObject)
        this.modalMainButtonDisabled = true
      }
    },
    checkIfObjectKeysAreEmpty(obj) {
      let keysAreEmpty = true
      if (obj && Object.keys(obj).length) {
        for (let key in obj) {
          if (obj[key] !== null && obj[key] != '') keysAreEmpty = false
        }
        return keysAreEmpty
      }
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    },
    changeEditMode() {
      this.newProfileMode = false
      this.editMode = !this.editMode
    },
    setNewProfileMode() {
      this.editMode = false
      this.newProfileMode = !this.newProfileMode
    },
    choosePositionFromPositionModal() {
      if (
        !this.checkIfObjectKeysAreEmpty(this.positionData) &&
        this.deliveryTypes.length > 0
      ) {
        this.stopLoadingMain()
        this.resetApiErrors()
        if (document.querySelector('.vpn_message__container') !== null) {
          document.querySelector('#appCheckout').style.marginTop = '24px'
        } else {
          document.querySelector('#appCheckout').style.marginTop = '0px'
        }
      }
    },
    switchPickpointsTemplate(type) {
      if (
        type !== this.activePickpointsTemplate &&
        this.showPickpointInfoModal
      ) {
        this.showPickpointInfoModal = false
      }
      this.activePickpoint = null
      this.activePickpointsTemplate = type
    },
    getDeliveryCompanyInfo(companyId) {
      const companyInfo = this.getDeliveryCompaniesList.find(
        (company) => company.id == companyId
      )
      return companyInfo ? companyInfo : { name: '' }
    },
    async selectPickpoint(pickpoint) {
      // console.trace('selectPickpoint UnAuth', pickpoint)
      this.$store.commit('UpdateSelectedPickpointInfo', pickpoint)
      this.selectedPickpointInfo = this.$store.state.selectedPickpointInfo
      if (this.selectedPickpointInfo) {
        this.$store.commit('UpdateSelectedDeliveryTypeService', pickpoint.TYPE)
        this.selectedPickpointInfo.deliveryCompanyName =
          this.getDeliveryCompanyInfo(pickpoint.TYPE).name
        this.selectedPickpointInfo.deliveryCompanyIcon =
          this.getDeliveryCompanyInfo(pickpoint.TYPE).icon
        this.selectedPickpointInfo.paymentSystems = this.getDeliveryCompanyInfo(
          pickpoint.TYPE
        ).paymentSystems
        this.selectedPickpointInfo.price = this.getDeliveryCompanyInfo(
          pickpoint.TYPE
        ).price

        await this.getPaymentTypesByService(pickpoint)
      }
      this.showPickpointInfoModal = false
      this.filteredPickpoints = this.pickpoints

      if (pickpoint) {
        this.clearCourierAddressMarker()
        await this.updateBasket()
      }
    },
    getPaymentTypeIcon(id) {
      let paymentSystemIconInfo = this.$store.getters.getPaymentTypeIcon(id)
      let image
      if (paymentSystemIconInfo) {
        image = paymentSystemIconInfo.src
      }
      return image
    },
    handleAddressFieldFocusOut(fieldName) {
      if (!isPostindexLookupCountry(this.getCountryCode)) return
      this.postindexLookup?.handleAddressFieldFocusOut(fieldName)
    },
    async formAddressField(googleObj, autocompleteQuery = '') {
      let area = ''
      let suggestApplied = false
      this.cancelAddressPending()
      if (!googleObj || !googleObj.address_components) {
        // Адрес не считается выбранным из саджеста
        this.$store.commit('setAddressPickedFromSuggest', false)
        this.resetAddressAnalytics()
      }

      if (googleObj && googleObj.address_components) {
        const gCountry =
          googleObj.address_components.find((el) =>
            el.types.includes('country')
          )?.short_name ?? false

        this.$store.commit('updateDefaultLocation', googleObj.geometry.location)
        if (this.activeDeliveryType?.ID === 'COURIER') {
          this.lastGooglePosition = {
            lat: googleObj.geometry.location.lat(),
            lng: googleObj.geometry.location.lng(),
          }

          // Москва, нельзя выбрать курьера день-в-день за пределами полигона
          this.moscowOutside = false
          const insideMoscow = this.$isObjectInPolygonMsk(
            this.lastGooglePosition
          )
          this.insideMoscowPolygon = insideMoscow
          if (
            this.$store.state.addressInfo.PROFILE.CITY === 'Москва' &&
            this.$store.state.selectedDeliveryTypeService ===
              'I_COURIER_1DAY' &&
            !insideMoscow
          ) {
            this.moscowOutside = true
            return false
          }
          // Киев нельзя выбрать курьера за пределами полигона
          this.kyivOutside = false
          const insideKyiv = this.$isObjectInPolygonKiev(
            this.lastGooglePosition
          )
          if (
            this.$store.state.addressInfo.PROFILE.CITY === 'Київ' &&
            !insideKyiv
          ) {
            this.kyivOutside = true
            return false
          }
          // Питер нельзя выбрать курьера за пределами полигона
          this.spbOutside = false
          const insideSpb = this.$isObjectInPolygonSpb(this.lastGooglePosition)
          this.insideSpbPolygon = insideSpb
          if (
            this.$store.state.selectedDeliveryTypeService ===
              'I_COURIER_1DAY' &&
            this.$store.state.addressInfo.PROFILE.CITY === 'Санкт-Петербург' &&
            !insideSpb
          ) {
            this.spbOutside = true
            return false
          }
        }
        this.addressInfo.formatted = googleObj.formatted_address

        area = findArea(googleObj, this.getCountryCode)
        let city = findCity(googleObj, this.getCountryCode)
        this.addressInfo.PROFILE.DISTRICT = findDistrict(googleObj)

        if (gCountry !== this.positionData.COUNTRY_CODE) {
          // в Крыму не показываем предупреждение
          if (!this.isCrimea(city.long_name)) {
            this.showDifferentCountryDetectorModal = true
            this.addressInfo.formatted = ''

            return
          }
        }

        // Puerto Rico area patch
        if (gCountry === 'PR' && this.getCountry.code === 'US') {
          area = { long_name: 'Puerto Rico' }
        }

        // U.S. Virgin Islands area patch
        if (gCountry === 'VI' && this.getCountry.code === 'US') {
          area = { long_name: 'U.S. Virgin Islands' }
        }

        let street = googleObj.address_components.find((field) =>
          field.types.includes('route')
        )

        if (!street && this.isKR) {
          street = googleObj.address_components.find((field) =>
            field.types.includes('sublocality_level_4')
          )
        }

        let building = googleObj.address_components.find((field) =>
          field.types.includes('street_number')
        )

        if (!building) {
          building = googleObj.address_components.find((field) =>
            field.types.includes('premise')
          )
        }

        if (!street && this.getCountry.code === 'CZ') {
          const streetName = googleObj.address_components.find((field) =>
            field.types.includes('neighborhood')
          )

          street = {
            long_name: streetName?.long_name || null,
          }
        }

        // добавляем фолбек в случае, если нету route, используем locality
        if (!street && building) {
          let fallbackStreet = googleObj.address_components.find(
            (field) =>
              field.types.includes('locality') &&
              field.types.includes('political')
          )

          if (fallbackStreet) {
            street = {
              long_name: fallbackStreet.long_name || null,
              short_name: fallbackStreet.short_name || null,
            }
          }
        }

        const postalCode = googleObj.address_components.find((field) =>
          field.types.includes('postal_code')
        )

        if ((area && area.long_name) || (area && area.short_name)) {
          this.addressInfo.PROFILE.AREA = area.long_name
            ? area.long_name
            : area.short_name
        }

        let localCity = googleObj.address_components.find(
          (field) =>
            field.types.includes('locality') &&
            field.types.includes('political')
        )

        if (localCity?.long_name === 'Москва') {
          // проверка кейсов "Щербинка, Москва", "Троицк, Москва" на наличие альтернативного значения в administrative_area_level_3
          const rayonMsk = googleObj.address_components.find(
            (field) =>
              field.types.includes('administrative_area_level_3') &&
              field.types.includes('political')
          )
          const isTroitsk = ['Щербинка', 'Троицк', 'Ново-Переделкино'].includes(
            rayonMsk?.long_name
          )

          // если это указанные города, то подставляем МО
          if (rayonMsk?.long_name !== 'Москва' && isTroitsk) {
            localCity = rayonMsk
          }
        }

        if (this.getCountry.code === 'SE') {
          if (!localCity) {
            localCity = googleObj.address_components.find((field) =>
              field.types.includes('postal_town')
            )
          }
          if (!localCity) {
            localCity = googleObj.address_components.find((field) =>
              field.types.includes('sublocality')
            )
          }
        } else {
          if (!localCity) {
            localCity = googleObj.address_components.find((field) =>
              field.types.includes('sublocality')
            )
          }

          if (!localCity) {
            localCity = googleObj.address_components.find((field) =>
              field.types.includes('postal_town')
            )
          }
        }

        if (!localCity) {
          localCity = googleObj.address_components.find(
            (field) =>
              field.types.includes('administrative_area_level_3') &&
              field.types.includes('political')
          )
        }

        if (!localCity) {
          localCity = googleObj.address_components.find(
            (field) =>
              field.types.includes('administrative_area_level_2') &&
              field.types.includes('political')
          )
        }

        if (
          !this.$noCityChangeCountries.includes(this.getCountryCode) &&
          !this.isDeliveryLoadingWhenProfileSelected &&
          city &&
          city.long_name !== this.positionData.CITY_NAME &&
          localCity &&
          localCity.long_name !== this.positionData.CITY_NAME
        ) {
          const newCityName = city.long_name
          const newArea =
            googleObj.address_components.find(
              (el) =>
                el.types.includes('administrative_area_level_1') &&
                el.types.includes('political')
            )?.long_name || ''

          // Отправляем событие в Sentry о показе модального окна смены города
          const showCount = incrementCityModalCounter()
          const newCity =
            city?.long_name || localCity?.long_name || 'Неизвестно'
          captureCityModalShown({
            context: getCheckoutContext(this.$store),
            showCount,
            oldCity: this.positionData.CITY_NAME,
            newCity,
          })

          this.confirmCityChangeModal = true
          this.needDefaultZoom = true
          this.cityToChange = googleObj

          // Сохраняем текущий адрес до того как watcher его перетрёт
          this.localityCheck.savedFormatted = this.addressInfo.formatted

          // Сохраняем данные нового города для проверки после подтверждения
          this.localityCheck.pendingCity = newCityName
          this.localityCheck.pendingArea = newArea
        } else {
          this.needDefaultZoom = false
          if (
            localCity &&
            localCity.long_name === this.positionData.CITY_NAME
          ) {
            city = localCity
          }

          if ((city && city.long_name) || (city && city.short_name)) {
            this.addressInfo.PROFILE.CITY = city.long_name
              ? city.long_name
              : city.short_name
          } else {
            // this.addressInfo.PROFILE.CITY = null
          }

          // street
          let str = ''
          switch (this.getCountryCode) {
            case 'PL':
              str = 'ADDRESS'
              break
            default:
              str = 'STREET'
              break
          }
          if ((street && street.long_name) || (street && street.short_name)) {
            this.addressInfo.PROFILE[str] = street.long_name
              ? street.long_name
              : street.short_name
          } else {
            this.addressInfo.PROFILE[str] = null
          }

          // build
          switch (this.getCountryCode) {
            case 'PL':
              str = 'BUILD_APART_NUM'
              break
            default:
              str = 'BUILD'
              break
          }
          if (
            (building && building.long_name) ||
            (building && building.short_name)
          ) {
            this.addressInfo.PROFILE[str] = building.long_name
              ? building.long_name
              : building.short_name
          } else {
            // Не перезаписываем существующее значение из профиля, если Google не нашел номер дома
            if (!this.addressInfo.PROFILE[str]) {
              this.addressInfo.PROFILE[str] = null
            }
          }
          if (
            (postalCode && postalCode.long_name) ||
            (postalCode && postalCode.short_name)
          ) {
            this.addressInfo.PROFILE.POSTINDEX = postalCode.long_name
              ? postalCode.long_name
              : postalCode.short_name
          } else {
            this.addressInfo.PROFILE.POSTINDEX = null
          }

          // Адрес пришёл из саджеста
          this.$store.commit('setAddressPickedFromSuggest', true)
          this.postindexLookup?.resetLookupBuild()

          // Ре-валидируем все поля адреса после заполнения из Google-саджеста
          for (const addrField of this.fieldsConfig?.ADDRESS_INFO_FIELDS ||
            []) {
            if (
              addrField.type === 'text' &&
              !['FIO', 'PHONE', 'EMAIL'].includes(addrField.name)
            ) {
              this.validateField(
                'ADDRESS_INFO_FIELDS',
                addrField.name,
                this.addressInfo.PROFILE[addrField.name]
              )
            }
          }

          if (this.validateAddressField(googleObj.formatted_address)) {
            this.courierAddressMarker.lat = googleObj.geometry.location.lat()
            this.courierAddressMarker.lng = googleObj.geometry.location.lng()
            this.setMapCordsForZoom(this.courierAddressMarker)
            this.selectedPickpointInfo =
              this.$options.data().selectedPickpointInfo
            this.activePickpointsTemplate = 'list'
          }

          if (this.isUSPanregion) {
            this.addressInfo.formatted = formattedUSA(
              this.addressInfo.PROFILE,
              area
            )
          }
        }
        // не отработает, если профиль с ручным вводом, т.к. не вызывается formAddressField
        const missingFields = getMissingAddressFields(
          this.fieldsConfig,
          this.addressInfo.PROFILE
        )

        if (missingFields.length > 0) {
          captureAutocompleteMissingFields({
            context: getCheckoutContext(this.$store),
            query:
              autocompleteQuery && typeof autocompleteQuery === 'string'
                ? autocompleteQuery.substring(0, 100)
                : '',
            missingFields,
            source: 'address',
          })
        }

        this.refreshKey++
        if (
          this.activeDeliveryType?.ID === 'COURIER' &&
          this.positionData.CITY_NAME === 'Москва'
        ) {
          this.updateBasket()
        }
        // refactoring console.log(
        //   'мы заполнили адрес',
        //   JSON.parse(JSON.stringify(this.addressInfo))
        // )
        if (!this.addressInfo.PROFILE.COUNTRY)
          this.addressInfo.PROFILE.COUNTRY = this.getCountry.code
        /* } else {
        if (e.key === "Backspace" || e.key === "Delete") {
          Object.keys(this.addressInfo.PROFILE).forEach((key) => {
            if (key !== 'COUNTRY' && key !== 'COUNTRY_CODE') this.$set(this.addressInfo.PROFILE, key, '');
          })
          this.validateAddressField(undefined);
        }
        this.refreshKey++; */
        this.courierAddressMarker.lat = googleObj.geometry.location.lat()
        this.courierAddressMarker.lng = googleObj.geometry.location.lng()
        this.setMapCordsForZoom(this.courierAddressMarker)

        if (suggestApplied) {
          this.reportSuggestDeliverySelected()
        }
      }
    },
    // setUseBonus(value) {
    //   this.useCoralWallet = value
    //   this.$store.commit('UpdateUseCoralWallet', value)
    // },
    focusToField(id) {
      const field = document.getElementById(id)
      field.focus()
    },
    closeConfirmCityChangeModal() {
      this.confirmCityChangeModal = false

      const city = this.addressInfo.PROFILE.CITY
      this.formattedAddress =
        this.addressInfo.PROFILE.AREA =
        this.addressInfo.formatted =
          city
    },
    // Проверка дубликата email/phone на беке
    // useStoreFallback = true только при начальной загрузке
    async checkDuplicateInDb() {
      if (!this.isBuyerFromFriend) return
      if (this.duplicateCheckInProgress) return
      if (this.showDuplicateModal) return

      const email = this.userInfo.EMAIL || ''
      const phone = this.userInfo.PHONE || ''
      this.duplicateCheckInProgress = true

      try {
        const { found, field } = await checkDuplicateEmailPhone(this.$axios, {
          email,
          phone,
        })

        if (found && field) {
          this.duplicateField = field

          if (field === 'email_phone' || this.isSecondDuplicateCheck) {
            this.duplicateModalMode = 'auth'
          } else {
            this.duplicateModalMode = 'confirm'
          }

          this.showDuplicateModal = true
        } else {
          this.mustEditBeforeNextStep = false
          this.isSecondDuplicateCheck = false
        }
      } finally {
        this.duplicateCheckInProgress = false
      }
    },
    onDuplicateConfirmData() {
      this.duplicateModalMode = 'auth'
    },
    onDuplicateMakeChanges() {
      this.showDuplicateModal = false
      this.mustEditBeforeNextStep = true
      this.isSecondDuplicateCheck = true
    },
    resetDuplicateModal() {
      this.showDuplicateModal = false
      this.duplicateField = null
      this.duplicateModalMode = 'confirm'
    },
    goToAuth() {
      this.resetDuplicateModal()
      window.location.href = '/auth_new/?BACK_URL=/checkout/'
    },
    closePopup() {
      this.addressPopup = false
    },

    focusAutocomplete() {
      if (this.hideGmapAutocomplete || this.showHiddenFields) return

      const el = document.getElementById('courier-address-field')
      if (!el) return

      el.focus()
      el.dispatchEvent(
        new KeyboardEvent('keydown', {
          key: 'ArrowDown',
          code: 'ArrowDown',
          bubbles: true,
        })
      )
    },

    // метод ничего не возвращал, из за этого ошибки не отображались наверху страницы
    getError(error) {
      const emptyBasketError = this.$t('error_checkout_empty_basket')

      return getError(error, emptyBasketError)
    },

    searchPickpoints(value) {
      this.searchTextPickpoints = value
      const pickpoints =
        this.filteredTypesPickpoints.length > 0
          ? this.filteredPickpoints
          : this.$store.state.pickpoints[this.positionData.CITY_NAME]
      if (value.length === 0) {
        this.searchedPickpoints = pickpoints
      } else {
        const normalizedSearch = normalizeString(value).toLowerCase()

        this.searchedPickpoints = pickpoints.filter((pickpoint) => {
          const normalizedAddress = normalizeString(
            pickpoint.ADDRESS || ''
          ).toLowerCase()
          const normalizedName = normalizeString(
            pickpoint.NAME || ''
          ).toLowerCase()
          const normalizedEmail = normalizeString(
            pickpoint.EMAIL || ''
          ).toLowerCase()

          return (
            normalizedAddress.includes(normalizedSearch) ||
            normalizedName.includes(normalizedSearch) ||
            normalizedEmail.includes(normalizedSearch)
          )
        })
      }
    },

    showMorePickpoints(event) {
      if (
        event.target.scrollTop + event.target.offsetHeight >=
        event.target.scrollHeight
      ) {
        this.itemsToShow += 10
      }
    },

    handleMaxLength(event, field) {
      this.editScenario()
      checkMaxLength(
        event,
        field,
        this.errorMessages,
        this.$t,
        this.addressInfo.PROFILE
      )
    },

    setStepDeliveryAutocomplete() {
      this.$nextTick(() => {
        const input = this.$refs.stepCity?.$refs?.gmapInput?.$el
        if (input) {
          input.type = 'search'
          input.focus()
        }
      })
    },
    // validateDeliveryTypes(dt) {
    //   if (!dt) return
    //   this.deliveryTypes = dt
    // },
    stopLoadingMain() {
      if (!this.loading.main) return
      this.loading.main = false
      if (this._mountedReported) {
        perfEnd('checkout:mounted', { report: false })
      } else {
        this._mountedReported = true
        perfEnd('checkout:mounted')
      }
      // «полная готовность» от navigation start: интервал checkout:mounted
      if (this.deliveryTypes.length && !this.$initError)
        perfPoint('checkout:ready')

      this._maybeReportDeliveryTypesVisible()
      this._maybeReportPaymentVisible()
      this._maybeReportWalletVisible()
    },
    isCrimea(city) {
      return isCityInCrimeaSync(city)
    },
    handleCreateNewAddress() {
      Object.assign(this.$data, this.$options.data())
      this.getFieldsConfig()
      this.UpdateSelectedProfile({})
      this.$store.commit('setCheckoutScenario', 'isNewProfile')
      this.setProfileMode('createNew')
      this.step = 2
    },
  },
}
</script>
<style scoped lang="scss">
#DeliveryTypes[data-type='PICKUP_EVENT'] {
  padding-bottom: 0 !important;
}
.afterTitle .popup {
  width: 310px !important;
}
.afterTitle .popup .bubble {
  width: 310px !important;
}
.afterTitle {
  display: flex;
  align-items: center;
  color: #333c47bf;
}
.afterTitle svg {
  width: 15px !important;
  height: 15px !important;
}
.popup {
  top: 30px !important;
  left: -8px !important;
}
.popup .bubble::before {
  top: 0 !important;
  left: 50% !important;
}
.coral-message {
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
  padding: 10px 15px;
  gap: 12px;
  background: #fffcf5;
  border: 1px solid #feecb9;
  border-radius: 4px;
  transition: opacity 300ms;
}

.coral-message-close {
  cursor: pointer;
  width: 30px;

  @media (max-width: 768px) {
    width: 50px;
  }

  @media (max-width: 480px) {
    width: 70px;
  }
}

.coral-message-warning {
  width: 50px;

  @media (max-width: 768px) {
    width: 70px;
  }

  @media (max-width: 480px) {
    width: 100px;
  }
}

.coral-message-text {
  color: #eda12f;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.vhidden {
  visibility: hidden;
}

label {
  margin-bottom: 6px;
  color: #75828b;
}

input[type='checkbox'],
input[type='radio'] {
  margin-bottom: 0;
}

.payment-selected {
  background-color: #ff585d08 !important;
  border: 2px solid #ff585d !important;
}

.select-om-map {
  color: #d6483d;
}
.close-map {
  color: #d6483d;
}
.manual-address {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 613px;

  &.line {
    border-top: 1px solid #e5ecf1;
    margin-top: 22px;
    padding-top: 22px;
  }

  &__text {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #646d74;
  }

  &__button {
    border: 1px solid #324a5d38;
    outline: none;
    border-radius: 10px;
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    color: #091620cc;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    max-width: 334px;
    width: 100%;

    @media (max-width: 480px) {
      max-width: 100%;
    }
  }
}
.close-manual-address {
  color: #e03b00 !important;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
}
.shipping-address {
  margin: 22px 0;
}

.radio-helper {
  &__container {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: #39444c;
  }

  &__icon {
    min-width: 24px;
    height: 24px;
  }
}
</style>
<style>
#position-input__modal-window::-webkit-search-cancel-button {
  /* Remove default */
  -webkit-appearance: none;
  /* Now your own custom styles */
  background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ACBFBF' %3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z' /%3E%3C/svg%3E%0A");
  height: calc(50px / 2);
  width: calc(50px / 2);
}

.whitespace-nowrap {
  white-space: nowrap;
}

.delivery-type__item {
  padding-left: 1rem;
  padding-right: 1rem;
  display: flex;
  justify-content: space-between;
}

.delivery-type__item__name {
  justify-content: space-between !important;
}

.z-10 {
  z-index: 10000 !important;
}

.component {
  -webkit-transition: opacity 0.2s ease-in-out;
  -moz-transition: opacity 0.2s ease-in-out;
  -ms-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
}
.component__loader {
  position: absolute;
  top: 0;
  right: 2rem;
}
.main__loader {
  top: 50%;
  left: 50%;
}
.loading {
  filter: alpha(opacity = 50);
  opacity: 50%;
}
.map__loader {
  position: relative;
  left: 0;
}
.pac-item {
  padding: 10px;
}

.pac-container {
  z-index: 99990 !important;
}

.saving {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.6;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  opacity: 0.8;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
